<template>
  <main-layout :selectedMenu="'home'">
    <section class="container containerUpVideo">
      <div class="no-identificaton" v-if="isFirst">
        <div class="up-video" ref="select_frame">
          <div class="upBox">
            <img src="/static/uploadvideo/upload_area_icon@2x.png" alt />
          </div>
          <p class="upTitle1">{{ $t("video.拖拽您要上传的视频文件于此") }}</p>
          <p class="upTitle2">{{ $t("video.或者") }}</p>
          <button
            class="upload-button"
            :disabled="!checked"
            :class="{ 'disable-button': !checked }"
            @click="reUpload"
          >
            {{ $t("global.上传视频") }}
          </button>
          <p class="upTitle3">
            {{
              $t(
                "video.视频支持格式：flv, mpg, mpeg, avi, wmv, mov, asf, rm, rmvb, mkv, mp4"
              )
            }}
          </p>
          <p class="upTitle4">{{ $t("video.文件大小：3G以内") }}</p>
          <p class="upTitle5">
            <span>*</span>
            {{ $t("video.请确保视频文件在您的电脑设备上可正常播放再进行上传") }}
          </p>
        </div>
        <div class="Protocol">
          <el-checkbox v-model="checked">
            {{ $t("global.并同意遵守") }}
            <router-link tag="span" to="/about/用户协议"
              >《{{ $t("global.MANA原创/授权视频声明用户规范") }}》</router-link
            >
            {{ $t("global.和") }}
            <router-link tag="span" to="/about/免责声明">{{
              $t("global.《MANA法律责任》")
            }}</router-link>
          </el-checkbox>
        </div>
        <p class="upTitle6">
          {{
            $t(
              "global.上传视频，即表示您已同意MANA上传服务条款，请勿上传色情，反动等违法视频"
            )
          }}
        </p>
        <div class="top-choose">
          <router-link tag="div" to="/about/投稿须知" class="hmessage">{{
            $t("global.投稿须知")
          }}</router-link>
          <span>|</span>
          <router-link tag="div" to="/about/常见问题" class="hmessage">{{
            $t("global.常见问题")
          }}</router-link>
        </div>
      </div>
      <input
        type="file"
        class="upInput"
        v-if="language === 'zh'"
        accept=".mov, .flv, .mpg, .mpeg, .avi, .wmv, .asf, .rm, .rmvb, .mkv, .mp4"
        @change="upVideo"
      />
      <input
        type="file"
        class="upInput"
        v-else
        accept=".mov, .flv, .mpg, .mpeg, .avi, .wmv, .asf, .rm, .rmvb, .mkv, .mp4"
        @change="changeVideo"
      />
      <div class="upVideo" :class="{ containerSwcond: true, hide: isFirst }">
        <div class="stepStatus" id="stepStatus">
          <p
            class="step"
            :class="{ active: step == 1 && !firstStep, completed: firstStep }"
            @click="step = 1"
          >
            <span v-if="!firstStep">1</span>
            <img
              v-else
              src="/static/uploadvideo/step_finished_icon@2x.png"
              alt
            />
            {{ $t("video.基本信息") }}
          </p>
          <img
            class="img-right"
            src="/static/uploadvideo/Upload_next_step_arrow@2x.png"
            alt
          />
          <p
            class="step"
            :class="{ active: step == 2 && !twoStep, completed: twoStep }"
            @click="gotoTwo"
          >
            <span v-if="!twoStep">2</span>
            <img
              v-else
              src="/static/uploadvideo/step_finished_icon@2x.png"
              alt
            />
            {{ $t("video.分类和标签") }}
          </p>
          <img
            class="img-right"
            src="/static/uploadvideo/Upload_next_step_arrow@2x.png"
            alt
          />
          <p class="step" :class="{ active: step == 3 }" @click="gotoThree">
            <span>3</span>
            {{ $t("video.商业转化") }}
          </p>
        </div>
        <div class="step1Box" v-if="step == 1">
          <div class="progress-wrap">
            <div class="progress-head">
              <!-- <div class="videoupload">
                <b>{{$t('global.视频上传')}}</b>
                {{$t('global.支持格式')}} flv,mpg,mpeg,avi,wmv,mov,asf,rm,rmvb,mkv,mp4 {{$t('global.文件大小限制')}}，{{$t('global.2G以内')}}
              </div>-->
              <div class="onloadings">
                <!-- <span class="videoed">
                  <img src="/static/uploadvideo/videoed.png" />
                </span>-->
                <div class="video-box">
                  <p v-if="uploadMessage">{{ uploadMessage }}</p>
                  <p v-else>{{ $t("global.视频上传中") }}...</p>
                </div>
                <div class="progress">
                  <div class="p-top" style="width: 0%" ref="progress"></div>
                </div>
                <div class="file-Name">{{ fileName }}</div>
                <div class="progressNumber">
                  <span ref="proNumber"></span>
                </div>
                <!-- <div class="right">{{uploadMessage}}</div> -->
                <div
                  class="againUpload againUploadSuccess"
                  @click="reUpload"
                  v-if="isUploadSuccess || !isUploading"
                >
                  <img
                    class="againImg"
                    src="/static/uploadvideo/reupload_icon_hover@2x.png"
                    alt
                  />
                  {{ $t("global.重新上传") }}
                </div>
                <div class="againUpload" v-else>
                  <img
                    class="againImg"
                    src="/static/uploadvideo/reupload_icon_unavaliable@2x.png"
                    alt
                  />
                  {{ $t("global.重新上传") }}
                </div>
              </div>
            </div>
          </div>
          <div class="basic-wrap">
            <div class="contain containtitle editTitles">
              <div class="left">
                <div class="font">
                  <em class="required">*</em>
                  {{ $t("global.视频封面") }}
                  <span
                    >{{ $t("video.图片格式") }}jpg、jpeg、png，{{
                      $t("global.图片比例")
                    }}16:9，{{ $t("global.尺寸") }}≥800*450，{{
                      $t("global.文件大小")
                    }}≤10MB</span
                  >
                </div>
              </div>
              <div class="right randomtopic">
                <div
                  class="upload uploadwidth uploadwidth1"
                  :style="thumb | bgImageUrl('', 160, 90)"
                  @click="reUploadF"
                >
                  <div
                    class="add-wrap"
                    :class="{ 'add-wrap-active': thumb != '' }"
                  >
                    <template v-if="thumb == ''"></template>
                  </div>
                  <div class="upFont">{{ $t("global.上传封面") }}</div>
                </div>
                <div class="onrandom">
                  <p class="defaults">
                    {{
                      $t(
                        "video.正在生成可选封面图，系统会默认选中第一张作为视频封面"
                      )
                    }}
                  </p>
                  <div class="dalayloading">
                    <img
                      src="/static/uploadvideo/loading.gif"
                      v-if="!thumbs[0]"
                    />
                    <div
                      v-else
                      :style="thumbs[0] | bgImageUrl"
                      @click="thumb = thumbs[0]"
                      :class="{ active: thumb == thumbs[0] }"
                    />
                  </div>
                  <div class="dalayloading">
                    <img
                      src="/static/uploadvideo/loading.gif"
                      v-if="!thumbs[1]"
                    />
                    <div
                      v-else
                      :style="thumbs[1] | bgImageUrl"
                      @click="thumb = thumbs[1]"
                      :class="{ active: thumb == thumbs[1] }"
                    />
                  </div>
                  <div class="dalayloading">
                    <img
                      src="/static/uploadvideo/loading.gif"
                      v-if="!thumbs[2]"
                    />
                    <div
                      v-else
                      :style="thumbs[2] | bgImageUrl"
                      @click="thumb = thumbs[2]"
                      :class="{ active: thumb == thumbs[2] }"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="contain containtitle" id="view1">
              <div class="left">
                <div class="font">
                  <em class="required">*</em>
                  {{ $t("global.作品标题") }}
                </div>
              </div>
              <div class="right real-name">
                <input
                  class="usertype"
                  type="text"
                  :maxlength="titleLength"
                  v-model="title"
                />
                <span>
                  <em>{{ getTitleLiength() }}</em
                  >/40
                </span>
              </div>
            </div>
            <div
              class="contain containtitle editTitles"
              v-if="language === 'zh'"
            >
              <div class="left">
                <div class="font">
                  <em class="required" v-if="isInternational">*</em>
                  {{ $t("global.作品标题") }}({{ $t("global.英文") }})
                </div>
              </div>
              <div class="real-name right">
                <input
                  class="usertype"
                  type="text"
                  :maxlength="enTitleLength"
                  v-model="enTitle"
                />
                <span>
                  <em>{{ getEnTitleLiength() }}</em
                  >/40
                </span>
              </div>
            </div>
            <div class="contain containtitle clearfix" id="view2">
              <div class="typeLeft">
                <div class="left">
                  <div class="font">
                    <em class="required">*</em>
                    {{ $t("global.类型") }}
                  </div>
                </div>
                <div class="right female">
                  <input
                    type="radio"
                    id="female"
                    name="sex"
                    :checked="isOriginal == '1'"
                    @change="chagneOriginal('1')"
                  />
                  <label for="female">{{ $t("global.原创") }}</label>
                  <input
                    type="radio"
                    id="male"
                    name="sex"
                    :checked="isOriginal == '2'"
                    @change="chagneOriginal('2')"
                  />
                  <label for="male">{{ $t("global.非原创") }}</label>
                </div>
              </div>
              <div class="timeRight">
                <div class="left">
                  <div class="font">
                    <em class="required">*</em>
                    {{ $t("video.创作时间") }}
                  </div>
                </div>
                <div class="right female">
                  <el-select
                    v-model="creationYear"
                    clearable
                    :placeholder="$t('video.年份')"
                  >
                    <el-option
                      v-for="item in optionsYear"
                      :key="item.label"
                      :label="item.value"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="creationMonth"
                    clearable
                    :placeholder="$t('video.月份(选填)')"
                  >
                    <el-option
                      v-for="item in optionsMonth"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="contain containtitle editTitles">
              <div class="left">
                <div class="font">
                  <em class="required" v-if="isInternational">*</em>
                  {{ $t("video.品牌 / 甲方") }}
                </div>
              </div>
              <div class="real-name right">
                <input class="usertype" type="text" v-model="brand" />
                <span>
                  <em>{{ brand.length }}</em
                  >/20
                </span>
              </div>
            </div>
            <div class="contain containtitle editTitles">
              <div class="left">
                <div class="font">
                  <em class="required">*</em>
                  {{ $t("global.创作者") }}
                  <span>{{ $t("global.上下拖拽可调整排序") }}</span>
                </div>
              </div>
              <div class="right">
                <div class="otherCreaterStyle">
                  <draggable
                    v-model="otherCreaterArr"
                    chosenClass="chosen"
                    forceFallback="true"
                    group="people"
                    animation="500"
                  >
                    <div
                      class="otherCitem"
                      v-for="(item, index) in otherCreaterArr"
                      :key="index"
                    >
                      <img
                        :src="
                          item.avatar
                            | imageUrl('/static/profile_img_default.png',40,40)
                        "
                        class="fanHead"
                      />
                      <span class="nickname">{{ item.nickname }}</span>
                      <el-input
                        class="role"
                        :maxlength="8"
                        v-model="item.role"
                        :placeholder="`${$t('global.在作品中的角色')}，${$t(
                          'global.选填'
                        )}`"
                      ></el-input>
                      <span class="roleLen">{{ item.role?item.role.length:0 }}/8</span>
                      <span
                        @click="deleteOtherCreater(index)"
                        v-if="!item.isUser"
                        class="deleteOC"
                        >{{ $t("global.删除") }}</span
                      >
                    </div>
                  </draggable>
                </div>
                <el-select
                  v-model="chooseJoin.nickname"
                  filterable
                  remote
                  :remote-method="searchUser"
                  :placeholder="$t('global.选择共同创作者')"
                  class="elselect"
                >
                  <el-option
                    v-for="(item, index) in fanlist"
                    :key="index"
                    :value="deteleHtml(item.nickname)"
                  >
                    <div @click="chooseJoin = item">
                      <img
                        :src="
                          item.avatar
                            | imageUrl('/static/profile_img_default.png',40,40)
                        "
                        class="step2-fanHead"
                      />
                      <i v-html="item.nickname"></i>
                    </div>
                  </el-option>
                </el-select>
                <el-button type="primary" @click="addCreater">{{
                  $t("global.确定")
                }}</el-button>
              </div>
            </div>

            <div class="contain containtitle" id="view3">
              <div class="left">
                <div class="font">
                  <em class="required">*</em>
                  {{ $t("video.作品介绍") }}
                </div>
              </div>
              <div class="textType">
                <span :class="{ active: textTer }" @click="textTer = true">{{
                  $t("video.纯文字版")
                }}</span>
                <span :class="{ active: !textTer }" @click="textTer = false">{{
                  $t("video.图文并茂版")
                }}</span>
              </div>
              <div v-if="textTer">
                <p class="zhText" v-if="language === 'zh'">
                  <img
                    v-if="introductionText"
                    src="/static/uploadvideo/info_filled_tick@2x.png"
                    alt
                  />
                  {{ $t("video.中文介绍") }}
                </p>
                <div class="real-name textareaname right">
                  <textarea id="peopleDT" v-model="introductionText"></textarea>
                </div>
                <div v-if="language === 'zh'">
                  <p class="enText">
                    <img
                      v-if="enIntroductionText"
                      src="/static/uploadvideo/info_filled_tick@2x.png"
                      alt
                    />
                    {{ $t("video.英文介绍（选填）") }}
                  </p>
                  <div class="real-name textareaname right">
                    <textarea
                      id="peopleDT"
                      v-model="enIntroductionText"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="imageText">
                  <div class="activeImageText" v-if="language === 'zh'">
                    <span
                      :class="{ imageTextActive: textzh }"
                      @click="textzh = true"
                    >
                      <img
                        v-if="introduction"
                        :src="
                          textzh
                            ? '/static/uploadvideo/info_filled_tick_active@2x.png'
                            : '/static/uploadvideo/info_filled_tick@2x.png'
                        "
                        alt
                      />
                      {{ $t("video.中文介绍") }}
                    </span>
                    <span
                      :class="{ imageTextActive: !textzh }"
                      @click="textzh = false"
                    >
                      <img
                        v-if="enIntroduction"
                        :src="
                          !textzh
                            ? '/static/uploadvideo/info_filled_tick_active@2x.png'
                            : '/static/uploadvideo/info_filled_tick@2x.png'
                        "
                        alt
                      />
                      {{ $t("video.英文介绍（选填）") }}
                    </span>
                  </div>
                  <tinymc-editor
                    v-if="textzh"
                    class="editor"
                    :content="introduction"
                    @changeEdit="updateContent1"
                  />
                  <tinymc-editor
                    v-else
                    class="editor"
                    :content="enIntroduction"
                    @changeEdit="updateContent2"
                  />
                </div>
              </div>
            </div>
            <div class="contain containtitle upload-wrap">
              <div class="photoAlbum">
                {{ $t("video.图片相册") }}
                <span
                  >{{ $t("global.选填") }}，{{
                    $t("global.格式")
                  }}jpg、jpeg、png，{{ $t("global.文件大小") }}≤3MB，{{
                    $t("global.图片比例")
                  }}16:9，{{ $t("global.尺寸") }}≥800*450</span
                >
              </div>
              <div class="right upcontent clearfix">
                <div class="upcontent1">
                  <div
                    class="upload"
                    v-for="(item, index) in images"
                    :key="index"
                    :style="item | bgImageUrl"
                  >
                    <img
                      @click="detaleImage(index)"
                      class="deteleImg"
                      src="/static/uploadvideo/img_x_del_icon@2x.png"
                      alt
                    />
                  </div>

                  <div class="upload clickloads uploadwidth">
                    <div class="uploadImage" @click="upImgClick(2)">
                      <img
                        :src="
                          images.length
                            ? '/static/uploadvideo/upload_more_img_block@2x.png'
                            : '/static/uploadvideo/upload_img_block@2x.png'
                        "
                        alt
                        class="add"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="addLabel">
            <div class="contain containtitle clearfix">
              <div class="left">
                <div class="font">
                  <em class="required">*</em>
                  {{ $t("global.开放下载") }}
                </div>
              </div>
              <div>
                <input
                  type="radio"
                  id="noOpen"
                  name="allowDownload"
                  :checked="allowDownload === 2"
                  @change="changeOpen(2)"
                />
                <label for="noOpen">{{ $t("global.不开放") }}</label>
                <input
                  type="radio"
                  id="open"
                  name="allowDownload"
                  :checked="allowDownload === 1"
                  @change="changeOpen(1)"
                />
                <label for="open">{{ $t("global.开放") }}</label>
              </div>
              <div class="explain">
                {{
                  $t(
                    "video.请仔细考虑此作品是否愿意开放给所有MANA认证用户进行免费下载；下载的视频将会带有MANA的Logo水印和您的MANA账号昵称，这将有利于您的作品在网络传播，被更多人看见。"
                  )
                }}
                <el-popover
                  placement="right"
                  width="400"
                  trigger="click"
                  @hide="$refs.watermark_sample.pause()"
                >
                  <div class="watermark_sample">
                    <video
                      src="https://video.manamana.net/MANA_watermark_sample.m4v"
                      ref="watermark_sample"
                      controls
                    ></video>
                  </div>
                  <a
                    href="javascript:;"
                    slot="reference"
                    class="show_watermark_sample"
                    >{{ $t("global.查看示例") }}</a
                  >
                </el-popover>
              </div>
            </div>
          </div>
          <div class="operate-btn">
            <a class="publish" @click="goBack">{{ $t("global.返回") }}</a>
            <a class="review" @click="firstSubmit">{{ $t("global.下一步") }}</a>
          </div>
        </div>
        <div
          class="step2Box"
          v-if="step == 2"
          @click.stop.prevent="hideAddInput"
        >
          <p class="step2_title1" id="view4">{{ $t("video.分类和标签") }}</p>
          <p class="step2_title2">
            {{
              $t(
                "video.填写更多标签信息，方便您的作品被更多地浏览和准确地筛选到"
              )
            }}
          </p>
          <div class="step2_type">
            <div class="title_text">
              <i>*</i>
              <span>{{ $t("video.分类") }}</span>
              {{ $t("global.最多选择5个") }}
            </div>
            <span
              class="selelTitle"
              @click.stop.prevent="selectCategory"
              v-if="!isselectTags.length"
              >{{ $t("video.+ 选择类别标签") }}</span
            >
            <div class="moretitle" v-else>
              <span v-for="(item, i) in isselectTags" :key="i" class="active">{{
                language === "zh" ? item.data.name : item.data.enName
              }}</span>
              <a class="clickaddtitle1" @click.stop.prevent="selectCategory">
                <i class="editImg"></i>
                {{ $t("video.编辑标签") }}
              </a>
            </div>
          </div>
          <div class="step2_industry">
            <div class="title_text">
              <span>{{ $t("global.行业") }}</span>
              {{ $t("video.选填，最多选择3个") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags1.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags1.id, 1)"
                :class="{ active: isSelectOne(item.id, tags1Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a class="clickaddtitle1" @click.stop.prevent="openAddIndustry">{{
                $t("video.+新标签")
              }}</a>
              <template v-if="addIndustry">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newIndustry"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(1, tags1.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <div class="step2_scene">
            <div class="title_text">
              <span>{{ $t("video.应用场景") }}</span>
              {{ $t("video.选填，最多选择3个") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags2.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags2.id, 2)"
                :class="{ active: isSelectOne(item.id, tags2Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a
                class="clickaddtitle1"
                @click.stop.prevent="openAddApplication"
                >{{ $t("video.+新标签") }}</a
              >
              <template v-if="addApplication">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newApplication"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(2, tags2.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <div class="step2_hot">
            <div class="title_text">
              <span>{{ $t("global.热门标签") }}</span>
              {{ $t("global.选填") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags3.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags3.id, 3)"
                :class="{ active: isSelectOne(item.id, tags3Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a class="clickaddtitle1" @click.stop.prevent="addHot = true">{{
                $t("video.+新标签")
              }}</a>
              <template v-if="addHot">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newHot"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(3, tags3.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <p class="step2_title1">{{ $t("video.软硬件及工具") }}</p>
          <p class="step2_title2">
            {{ $t("video.填写完整的标签信息将有利于您的作品被更多地浏览") }}
          </p>
          <div class="step2_tool">
            <div class="title_text">
              <span>{{ $t("video.软件") }}</span>
              {{ $t("global.选填") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags4.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags4.id, 4)"
                :class="{ active: isSelectOne(item.id, tags4Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a
                class="clickaddtitle1"
                @click.stop.prevent="addSoftware = true"
                >{{ $t("video.+新标签") }}</a
              >
              <template v-if="addSoftware">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newSoftware"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(4, tags4.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <div class="step2_tool">
            <div class="title_text">
              <span>{{ $t("video.硬件") }}</span>
              {{ $t("global.选填") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags5.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags5.id, 5)"
                :class="{ active: isSelectOne(item.id, tags5Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a
                class="clickaddtitle1"
                @click.stop.prevent="addHardware = true"
                >{{ $t("video.+新标签") }}</a
              >
              <template v-if="addHardware">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newHardware"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(5, tags5.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <div class="step2_tool">
            <div class="title_text">
              <span>{{ $t("video.材料") }}</span>
              {{ $t("global.选填") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags6.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags6.id, 6)"
                :class="{ active: isSelectOne(item.id, tags6Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a class="clickaddtitle1" @click.stop.prevent="addStuff = true">{{
                $t("video.+新标签")
              }}</a>
              <template v-if="addStuff">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newStuff"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(6, tags6.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <div class="step2_tool">
            <div class="title_text">
              <span>{{ $t("video.技术手段及其他工具") }}</span>
              {{ $t("global.选填") }}
            </div>
            <div class="moretitle">
              <span
                v-for="(item, index) in tags7.tagEditFroms"
                :key="index"
                @click="selectOtherTag(item, tags7.id, 7)"
                :class="{ active: isSelectOne(item.id, tags7Select) }"
                >{{ language === "zh" ? item.name : item.enName }}</span
              >
              <a class="clickaddtitle1" @click.stop.prevent="addTool = true">{{
                $t("video.+新标签")
              }}</a>
              <template v-if="addTool">
                <div class="userinfortit1" @click.stop.prevent>
                  <input
                    type="text"
                    v-model="newTool"
                    :placeholder="$t('global.输入标签')"
                  />
                  <a @click.stop.prevent="addNewTagOther(7, tags7.id)">{{
                    $t("global.确定")
                  }}</a>
                </div>
              </template>
            </div>
          </div>
          <div class="step2_buttom">
            <span class="back" @click="step = 1">{{ $t("video.上一步") }}</span>
            <span class="next" @click="twoSubmit">{{
              $t("global.下一步")
            }}</span>
          </div>
        </div>
        <div class="step3Box" v-if="step == 3">
          <div class="condition">
            <p class="condition_title">
              <span>{{ $t("video.展示条件") }}</span>
              {{ $t("video.选填，可多选") }}
            </p>
            <div class="condition_ter clearfix">
              <p class="left_ter">
                <span
                  @click="door1 = !door1"
                  :class="{ active: door1 == true }"
                ></span>
                {{ $t("video.适用于室内") }}
              </p>
              <p class="left_ter">
                <span
                  @click="door2 = !door2"
                  :class="{ active: door2 == true }"
                ></span>
                {{ $t("video.适用于室外") }}
              </p>
              <p class="right_ter">
                <span
                  @click="door3 = !door3"
                  :class="{ active: door3 == true }"
                ></span>
                {{ $t("video.适用于线上及虚拟空间") }}
              </p>
            </div>
          </div>
          <div class="mode">
            <p class="mode_title">
              <span>{{ $t("video.商业合作方式") }}</span>
              {{
                $t(
                  "video.选填，可多选；以下信息仅用于该作品商业转化的接洽，不会在网站及APP上公开展示，未经创作者确认不会与第三方分享。"
                )
              }}
            </p>
            <div class="mode_ter">
              <p class="left_ter">
                <span
                  @click="lease = !lease"
                  :class="{ active: lease == true }"
                ></span>
                {{ $t("video.租赁") }}
                <el-select
                  v-model="leaseValue"
                  :disabled="!lease"
                  :placeholder="$t('video.请选择价格范围')"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-if="leaseValue == 8"
                  :placeholder="$t('video.请填写价格或价格范围')"
                  type="text"
                  v-model="leasePrice"
                  class="customPrice2"
                ></el-input>
              </p>
              <p class="left_ter">
                <span
                  @click="sale = !sale"
                  :class="{ active: sale == true }"
                ></span>
                {{ $t("video.售卖") }}
                <el-select
                  v-model="saleValue"
                  :disabled="!sale"
                  :placeholder="$t('video.请选择价格范围')"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-if="saleValue == 8"
                  :placeholder="$t('video.请填写价格或价格范围')"
                  type="text"
                  v-model="salePrice"
                  class="customPrice2"
                ></el-input>
              </p>
              <p class="left_ter">
                <span
                  @click="customized = !customized"
                  :class="{ active: customized == true }"
                ></span>
                {{ $t("video.定制") }}
                <el-select
                  v-model="customizedValue"
                  :disabled="!customized"
                  :placeholder="$t('video.请选择价格范围')"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-if="customizedValue == 8"
                  :placeholder="$t('video.请填写价格或价格范围')"
                  type="text"
                  v-model="customizedPrice"
                  class="customPrice2"
                ></el-input>
              </p>
              <p class="left_ter">
                <span
                  @click="other = !other"
                  :class="{ active: other == true }"
                ></span>
                {{ $t("video.其他") }}
                <el-input
                  :disabled="!other"
                  :placeholder="$t('video.请填写其他合作方式')"
                  v-model="otherPrice"
                  class="customPrice1"
                ></el-input>
              </p>
            </div>
          </div>
          <div class="step3_bottom">
            <span class="step3_back" @click="step = 2">{{
              $t("video.上一步")
            }}</span>
            <span class="step3_dri" @click="submit">{{
              $t("global.提交")
            }}</span>
          </div>
        </div>
        <input
          type="file"
          class="upInputIMG"
          accept="image/*"
          @change="upImg"
        />
        <input
          type="file"
          class="upInputIMG1"
          accept="image/*"
          @change="upImg1"
        />
        <cropImg
          ref="cropComponent"
          :dialogWidth="option.dialogWidth"
          :dialogHeight="option.dialogHeight"
          :cropWidth="option.cropWidth"
          :cropHeight="option.cropHeight"
          :minWidth="option.minWidth"
          :minHeight="option.minHeight"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :maxImgSize="option.maxImgSize"
          @update-img="updateImage"
          :is-upload="isUpload"
        ></cropImg>
      </div>
    </section>
    <uploadVideo
      ref="uploadVideo"
      @uploadVideoProgress="uploadVideoProgress"
      @beforeUploadVideo="beforeUploadVideo"
      @uploadVideoFail="uploadVideoFail"
      @uploadVideoSuccess="uploadVideoSuccess"
      @getDuration="getDuration"
    />
    <div class="typePop" v-if="showTypeBox">
      <div class="typePopBox" @click.stop.prevent="secondTag = false">
        <p class="type_title">
          {{ $t("video.请选择类别") }}
          <span class="most">{{ $t("video.最多选择5个") }}</span>
          <span class="close" @click="close"></span>
        </p>
        <div class="categoryLabel">
          <div class="label_title clearfix">
            <span
              v-for="(item, index) in tagsClassification"
              :key="index"
              @click="changeIndustryIds(item)"
              :class="{ active: item.id == tagId }"
            >
              {{ language === "zh" ? item.name : item.enName || item.name }}
              <i v-if="amountNumber(item.id)">({{ amountNumber(item.id) }})</i>
            </span>
            <a class="clickaddtitle1" @click.stop.prevent="openOneTag">{{
              $t("video.+新标签")
            }}</a>
            <template v-if="oneTag">
              <div class="userinfortit1" @click.stop.prevent>
                <input
                  type="text"
                  v-model="oneNewTag"
                  :placeholder="$t('global.输入标签')"
                />
                <a @click="addOneNewTag">{{ $t("global.确定") }}</a>
              </div>
            </template>
          </div>
        </div>
        <div class="subdivide" v-if="subClassification.length">
          <p class="subdivide_title">
            {{ $t("video.请选择此分类下细分标签") }}
          </p>
          <div
            class="label_title clearfix"
            @click.stop.prevent="secondTag = false"
          >
            <span
              v-for="(item, index) in subClassification"
              :key="index"
              @click="selectTag(item)"
              :class="{ active: isSelectOne(item.id, pointerTag) }"
              >{{ language === "zh" ? item.name : item.enName || item.name }}</span
            >
            <a
              v-if="isHidenAdd"
              class="clickaddtitle1"
              @click.stop.prevent="openAddNewTag"
              >{{ $t("video.+新标签") }}</a
            >
            <template v-if="secondTag">
              <div class="userinfortit1" @click.stop.prevent>
                <input
                  type="text"
                  v-model="newTag"
                  :placeholder="$t('global.输入标签')"
                />
                <a @click="addNewTag">{{ $t("global.确定") }}</a>
              </div>
            </template>
          </div>
        </div>
        <div class="selected" v-if="selectTags.length">
          <p class="selected_title">
            {{ $t("video.已选择") }}{{ selectTags.length
            }}{{ $t("video.个分类标签") }}
          </p>
          <div class="selected_label_title clearfix">
            <span v-for="(item, i) in selectTags" :key="i">
              {{ language === "zh" ? item.data.name : item.data.enName || item.data.name }}
              <i @click.stop.prevent="selectTag(item.data, item.groupId)"></i>
            </span>
          </div>
        </div>
        <div class="determine" @click="dinfTags" v-if="selectTags.length">
          {{ $t("global.确定") }}
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import * as qiniu from "qiniu-js";
import cropImg from "@/components/CropImg.vue";
import uploadVideo from "@/components/uploadVideo/uploadVideo";
import tinymcEditor from "@/components/editor/Editor";
import draggable from "vuedraggable";
import tools from "@/util/tools";

export default {
  name: "UpVideo",
  metaInfo() {
    return {
      title: this.$t("global.上传视频") + " | MANA",
    };
  },
  data() {
    return {
      options: [
        { value: "1", label: this.$t("video.2万元以下") },
        { value: "2", label: this.$t("video.2万元~5万元") },
        { value: "3", label: this.$t("video.5万元~10万元") },
        { value: "4", label: this.$t("video.10万元~30万元") },
        { value: "5", label: this.$t("video.30万元~50万元") },
        { value: "6", label: this.$t("video.50万元~100万元") },
        { value: "7", label: this.$t("video.100万元以上") },
        { value: "8", label: this.$t("video.自定义价格") },
      ],
      businessFormId: null,
      door1: false,
      door2: false,
      door3: false,
      lease: false,
      leaseValue: "",
      leasePrice: "",
      sale: false,
      saleValue: "",
      salePrice: "",
      customized: false,
      customizedValue: "",
      customizedPrice: "",
      other: false,
      otherValue: "",
      otherPrice: "",
      showTypeBox: false,
      textTer: true,
      textzh: true,
      option: {
        fixed: true,
        fixedNumber: [16, 9],
        dialogWidth: 900,
        dialogHeight: 580,
        cropWidth: 800,
        cropHeight: 450,
        minWidth: 800,
        minHeight: 450,
        maxImgSize: 2000
      },
      isInternational: false,
      imageCount: 3,
      isFirst: true,
      isIden: "",
      cePhone: "",
      checkList: [],
      checkList1: [],
      fileName: "",
      checked: true,
      contentIndex: 1,
      selectedFilters: [],
      hotTagList: [],
      industryList: [],
      professionList: [],
      productLable: "",
      equipmentLable: "",
      fanlist: [],
      title: "",
      titleLength: null,
      enTitle: "",
      enTitleLength: null,
      hash: "",
      key: "",
      videoWidth: null,
      videoHeight: null,
      thumb: "",
      images: [],
      introduction: "",
      enIntroduction: "",
      introductionText: "",
      enIntroductionText: "",
      isOriginal: "2",
      allowDownload: 2,
      activityId: "",
      industryIds: [],
      professionIds: [],
      creatorIds: [],
      chooseNmae: "",
      otherCreaterArr: [],
      search: "",
      token: "",
      sendFlag: true,
      submitFlag: true,
      videoId: undefined,
      user: {},
      addIndustry: false,
      newIndustry: "",
      addApplication: false,
      newApplication: "",
      addHot: false,
      newHot: "",
      addSoftware: false,
      newSoftware: "",
      addHardware: false,
      newHardware: "",
      addStuff: false,
      newStuff: "",
      addTool: false,
      newTool: "",
      isHidenAdd: true,

      phone: "",
      code: "",
      thumbs: [],
      hotIds: [],
      otherHotIds: [],
      newHot: "",
      addHot: false,
      equipment: [],
      newEquipment: "",
      addEquipment: false,
      equipmentIds: [],
      otherEquimentIds: [],
      isActive0: false,
      isActive1: false,
      isActive2: false,
      isUpload: false,
      isUploading: false,
      isUploadSuccess: true,
      uploadMessage: "",
      chooseJoin: {},
      showDialog: false,
      cancelObj: {},
      creationMonth: null,
      creationYear: null,
      brand: "",
      step: 1,
      tagsClassification: [],
      subClassification: [],
      subClassifications: [],
      selectTags: [],
      isselectTags: [],
      pointerTag: [],
      tagId: null,
      videoTagsGroup: [],
      videoTagGroup: [],
      oneNewTag: "",
      newTag: "",
      oneTag: false,
      secondTag: false,
      showConditions: "",
      firstStep: false,
      twoStep: false,
      threeStep: false,
      otherTags: [],
      Year: null,
      tags1: {},
      tags2: {},
      tags3: {},
      tags4: {},
      tags5: {},
      tags6: {},
      tags7: {},
      tags1Select: [],
      tags2Select: [],
      tags3Select: [],
      tags4Select: [],
      tags5Select: [],
      tags6Select: [],
      tags7Select: [],
      businessForm: {},
      optionsMonth: [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
        { value: "6", label: "6" },
        { value: "7", label: "7" },
        { value: "8", label: "8" },
        { value: "9", label: "9" },
        { value: "10", label: "10" },
        { value: "11", label: "11" },
        { value: "12", label: "12" },
      ],
      optionsYear: [],
      isOkOpen: false,
      isPub: "0",
    };
  },
  components: {
    MainLayout,
    service,
    cropImg,
    uploadVideo,
    tinymcEditor,
    draggable,
  },
  computed: {
    getProgress() {
      return this.progress;
    },
    language() {
      return this.$language();
    },
  },
  created() {
    document.body.style.overflow = "";
    this.init();
    var myDate = new Date();
    var tYear = myDate.getFullYear();
    this.Year = Number(tYear);
    this.optionsYear = [
      { label: "1", value: this.Year },
      { label: "2", value: this.Year - 1 },
      { label: "3", value: this.Year - 2 },
      { label: "4", value: this.Year - 3 },
      { label: "5", value: this.Year - 4 },
      { label: "6", value: this.Year - 5 },
      { label: "7", value: this.Year - 6 },
      { label: "8", value: this.Year - 7 },
      { label: "9", value: this.Year - 8 },
      { label: "10", value: this.Year - 9 },
      { label: "11", value: this.Year - 10 },
      { label: "12", value: this.Year - 11 },
      { label: "13", value: this.Year - 12 },
      { label: "14", value: this.Year - 13 },
      { label: "15", value: this.Year - 14 },
      { label: "16", value: this.Year - 15 },
      { label: "17", value: this.Year - 16 },
      { label: "18", value: this.Year - 17 },
      { label: "19", value: this.Year - 18 },
      { label: "20", value: this.Year - 19 },
    ];
  },
  watch: {
    "$store.state.accountUser"(val) {
      this.user = val;
      this.cePhone = this.user.phone;
    },
    fileName(val) {
      if (this.title) {
      } else {
        this.title = val.split(".")[0];
      }
    },
    isOriginal(val) {
      if (val == "1") {
        this.isOriginal = "1";
      } else {
        this.isOriginal = "2";
      }
    },
    professionIds(value) {
      if (value && value.length > 5) {
        this.$message(this.$t("global.最多选择5个"));
        this.professionIds.splice(value.length - 1, 1);
      }
    },
    selectTags() {
      if (this.selectTags.length > 5) {
        this.selectTags.splice(this.selectTags.length - 1, 1);
      }
    },
    pointerTag() {
      if (this.pointerTag.length > 5) {
        this.$message(this.$t("global.最多选择5个"));
        this.pointerTag.splice(this.pointerTag.length - 1, 1);
      }
    },
    industryIds() {
      if (this.industryIds.length > 3) {
        this.$message(this.$t("global.最多选择3个"));
        this.industryIds.splice(this.industryIds.length - 1, 1);
      }
    },
    tags1Select() {
      if (this.tags1Select.length > 3) {
        this.$message(this.$t("global.最多选择3个"));
        this.tags1Select.splice(this.tags1Select.length - 1, 1);
      }
    },
    tags2Select() {
      if (this.tags2Select.length > 3) {
        this.$message(this.$t("global.最多选择3个"));
        this.tags2Select.splice(this.tags2Select.length - 1, 1);
      }
    },
    titleLength(val) {
      if (val > 80) {
        this.title = this.title.substring(0, 40);
        return;
      }
    },
    enTitleLength(val) {
      if (val > 80) {
        this.enTitle = this.enTitle.substring(0, 40);
        return;
      }
    },
    brand() {
      if (this.brand.length > 20) {
        this.brand = this.brand.substring(0, 20);
        return;
      }
    },
    cePhone(val) {
      if (val != null && val != "") {
        this.isOriginal = "1";
      } else {
        this.isOriginal = "2";
      }
    },
    // enTitle() {
    //   if (this.enTitle.length > 80) {
    //     this.enTitle = this.enTitle.substring(0, 80);
    //     return;
    //   }
    // }
  },
  mounted() {
    if (this.$refs.select_frame) {
      this.$refs.select_frame.ondragleave = (e) => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
      };
      this.$refs.select_frame.ondrop = (e) => {
        e.preventDefault(); //阻止拖放后的浏览器默认行为
        var $this = this;
        if (!this.checked) {
          return;
        }
        this.initFile();
        this.fileName = e.dataTransfer.files[0].name;
        this.isFirst = false;
        const data = e.dataTransfer.files[0];
        const type = e.dataTransfer.files[0].type;
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(e.dataTransfer.files[0]);
        videoElement.addEventListener("loadedmetadata", function () {
          $this.videoWidth = videoElement.videoWidth;
          $this.videoHeight = videoElement.videoHeight;
        })
        if (!tools.supportedVideoFormat(type)) {
          this.uploadMessage = `${this.$t("global.上传失败")},${this.$t(
            "global.请检查上传格式是否符合支持格式"
          )}`;
          return;
        }
        if (e.dataTransfer.files[0].size / 1024 / 1024 > 3072) {
          this.uploadMessage = `上传失败 , ` + this.$t("global.文件不能大于3G");
          this.$message.info(this.$t("global.文件不能大于3G"));
          return;
        }
        this.isUploading = true;

        if (this.language === "zh") {
          var observable;
          var subscription;
          var error = function (err) {
            document.querySelector(".upInput").value = "";
            $this.isUploading = false;
            $this.uploadMessage = $this.$t("global.上传失败");
          };

          var complete = function (res) {
            $this.isUploadSuccess = true;
            $this.isUploading = false;
            $this.uploadMessage = $this.$t("global.上传成功");
            $this.hash = res.hash;
            $this.key = res.key;
            let videoUrl = `/api/common/getVideoDuration`;
            $this.$http
              .get(videoUrl, { params: { fileName: res.key } })
              .then((response) => {
                var videoData = response;
                if (videoData.data != null && videoData.data != "") {
                  let duration = videoData.data;
                  $this.thumbs = [];
                  let time1 = $this.$jsonUtils.RandomNum(2, Number(duration));
                  let time2 = $this.$jsonUtils.RandomNum(2, Number(duration));
                  $this.thumbs[1] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time1}/w/800/h/450`;
                  $this.thumbs[2] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time2}/w/800/h/450`;
                  let thumb = `https://video.manamana.net/${$this.key}?vframe/jpg/offset/1/w/800/h/450`;
                  if ($this.thumb == "") {
                    $this.thumb = thumb;
                  }
                  $this.thumbs[0] = thumb;
                }
              });
          };

          var next = function (response) {
            var total = response.total;
            $this.$refs.progress.style.width = parseInt(total.percent) + "%";
            $this.$refs.proNumber.innerHTML = `${$this.$t("global.已上传")}${
              Math.round(total.percent * 100) / 100
            }%`;
          };

          var subObject = {
            next: next,
            error: error,
            complete: complete,
          };

          var config = {
            useCdnDomain: true,
            disableStatisticsReport: false,
            retryCount: 3,
            region: null,
          };
          var putExtra = {
            fname: $this.fileName.split(".")[0],
            params: {},
            mimeType: null,
          };
          this.$http.get("/api/common/upload/token/video").then((res) => {
            this.token = res.data;
            observable = qiniu.upload(
              data,
              Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
              this.token,
              putExtra,
              config
            );
            subscription = observable.subscribe(subObject);
          });
        } else {
          this.$refs.uploadVideo.addFile(e.dataTransfer.files[0]);
        }
      };
      this.$refs.select_frame.ondragenter = (e) => {
        e.preventDefault(); //阻止拖入时的浏览器默认行为
        //   this.$refs.select_frame.border = "2px dashed red";
      };
      this.$refs.select_frame.ondragover = (e) => {
        e.preventDefault(); //阻止拖来拖去的浏览器默认行为
      };
    }
  },
  methods: {
    init() {
      this.tagList();
      this.getOtherTags();
      if (this.checkUserInfo()) {
        this.reset();
        const videoId = this.$query.videoId;
        if (videoId) {
          // this.tagList();
          // this.getOtherTags();
          this.detail(videoId);
          this.videoId = videoId;
        }
        this.user = this.$store.state.accountUser;
        this.otherCreaterArr = [
          {
            creatorId: this.user.userId,
            avatar: this.user.avatar,
            nickname: this.user.nickname,
            isUser: true,
            role: "",
          },
        ];
        this.hotTagListF();
        this.categoryList();
        this.getOtherCreator();
        this.getEquipmentList();

        this.cePhone = this.user.phone;
      }
    },
    reset() {
      this.selectedFilters = "";
      this.creatorIds = [];
      this.title = "";
      this.introduction = "";
      this.thumb = "";
      this.images = [];
      this.allowDownload = 2;
      this.isOriginal = "2";
      this.equipment = [];
      this.hash = "";
      this.activityId = "";
      this.industryIds = [];
      this.professionIds = [];
      this.key = "";
      this.fileName = "";
      this.isUpload = false;
    },
    initFile() {
      this.isOriginal = "1";
      // this.title = "";
      this.thumbs = [];
      this.fileName = "";
      this.isUpload = false;
      this.isUploading = false;
      this.isUploadSuccess = false;
      this.uploadMessage = "";
      this.$refs.progress.style.width = "0%";
      this.$refs.proNumber.innerHTML = "";
    },
    detaleImage(index) {
      this.images = this.images.filter((item, i) => {
        return i != index;
      });
    },
    deteleHtml(html) {
      let reg = /(<\/?em.*?>)/gi;
      return html.replace(reg, "");
    },
    updateContent1(content) {
      this.introduction = content;
    },
    updateContent2(content) {
      this.enIntroduction = content;
    },
    upVideo(e) {
      if (!e.target.files[0]) {
        return;
      }
      var $this = this;
      this.initFile();
      this.fileName = e.target.files[0].name;
      this.isFirst = false;
      const type = e.target.files[0].type;
      let videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(e.target.files[0]);
      videoElement.addEventListener("loadedmetadata", function () {
        $this.videoWidth = videoElement.videoWidth;
        $this.videoHeight = videoElement.videoHeight;
      })
      if (!tools.supportedVideoFormat(type)) {
        this.uploadMessage = `${this.$t("global.上传失败")},${this.$t(
          "global.请检查上传格式是否符合支持格式"
        )}`;
        return;
      }
      if (e.target.files[0].size / 1024 / 1024 > 3072) {
        this.uploadMessage = `上传失败 , ` + this.$t("global.文件不能大于3G");
        this.$message.info(this.$t("global.文件不能大于3G"));
        return;
      }
      this.isUploading = true;

      var observable;
      var subscription;
      var error = function (err) {
        document.querySelector(".upInput").value = "";
        $this.isUploading = false;
        $this.uploadMessage = $this.$t("global.上传失败");
      };

      var complete = function (res) {
        $this.isUploadSuccess = true;
        $this.isUploading = false;
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.hash = res.hash;
        $this.key = res.key;
        let videoUrl = `/api/common/getVideoDuration`;
        $this.$http
          .get(videoUrl, { params: { fileName: res.key } })
          .then((response) => {
            var videoData = response;
            if (videoData.data != null && videoData.data != "") {
              let duration = videoData.data;
              $this.thumbs = [];
              let time1 = $this.$jsonUtils.RandomNum(2, Number(duration));
              let time2 = $this.$jsonUtils.RandomNum(2, Number(duration));
              $this.thumbs[1] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time1}/w/800/h/450`;
              $this.thumbs[2] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time2}/w/800/h/450`;
              let thumb = `https://video.manamana.net/${$this.key}?vframe/jpg/offset/1/w/800/h/450`;
              if ($this.thumb == "") {
                $this.thumb = thumb;
              }
              $this.thumbs[0] = thumb;
            }
          });
      };

      var next = function (response) {
        var total = response.total;
        $this.$refs.progress.style.width = parseInt(total.percent) + "%";
        $this.$refs.proNumber.innerHTML = `${$this.$t("global.已上传")}${
          Math.round(total.percent * 100) / 100
        }%`;
      };

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null,
      };
      var putExtra = {
        fname: $this.fileName.split(".")[0],
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/token/video").then((res) => {
        this.token = res.data;
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    changeVideo(e) {
      this.isFirst = false;
      const type = e.target.files[0].type;
      if (e.target.files[0].size / 1024 / 1024 > 3072) {
        this.isUploading = false;
        this.uploadMessage =
          `Upload Fail , ` + this.$t("global.文件不能大于3G");
        this.$message.info(this.$t("global.文件不能大于3G"));
        return;
      }
      if (!tools.supportedVideoFormat(type)) {
        this.isUploading = false;
        this.uploadMessage = `Upload Fail , Supported Format flv,mpg,mpeg,avi,wmv,mov,asf,rm,rmvb,mkv,mp4`;
        return;
      }
      this.isUploading = true;
      this.$refs.uploadVideo.addFile(e.target.files[0]);
    },
    uploadVideoProgress(percent) {
      this.$refs.progress.style.width = percent + "%";
      this.$refs.proNumber.innerHTML = `Upload ${percent}%`;
    },
    beforeUploadVideo(name) {
      this.initFile();
      this.isUploading = true;
      this.isFirst = false;
      this.fileName = name;
      this.key = "";
      this.hash = "";
    },
    uploadVideoFail(message) {
      document.querySelector(".upInput").value = "";
      this.uploadMessage = message;
    },
    checkUserInfo() {
      const peopleMessage = this.$store.state.peopleMessage;
      if (
        !(
          peopleMessage.avatar &&
          peopleMessage.nickname &&
          peopleMessage.gender &&
          (peopleMessage.phone || this.language !== "zh") &&
          peopleMessage.email &&
          peopleMessage.introduce &&
          (peopleMessage.country || peopleMessage.country === 0) &&
          peopleMessage.field
        )
      ) {
        this.$router.replace(
          `/UpVideo/perfectUserInfo?redirect=${
            location.pathname + location.search
          }`
        );
      }
      return true;
    },
    uploadVideoSuccess(key) {
      this.uploadMessage = `Upload complete`;
      this.isUploading = false;
      this.isUploadSuccess = true;
      this.key = key;
      this.thumbs = [];
      let time1 = this.$jsonUtils.RandomNum(2, Number(this.duration));
      let time2 = this.$jsonUtils.RandomNum(2, Number(this.duration));
      let thumb = `https://videos.manamana.net${this.key}?x-oss-process=video/snapshot,t_1000,f_jpg,w_800,h_450`;
      this.thumbs[1] = `https://videos.manamana.net${
        this.key
      }?x-oss-process=video/snapshot,t_${time1 * 1000},f_jpg,w_800,h_450`;
      this.thumbs[2] = `https://videos.manamana.net${
        this.key
      }?x-oss-process=video/snapshot,t_${time2 * 1000},f_jpg,w_800,h_450`;
      if (!this.thumb) {
        this.thumb = thumb;
      }
      this.thumbs[0] = thumb;
    },
    getDuration(duration) {
      this.duration = Math.round(duration);
    },
    changeOpen(num) {
      this.allowDownload = num;
    },
    handleClose() {
      this.isOriginal = "2";
    },
    changeEdit(content) {
      this.tinymceHtml = content;
    },
    addCreater() {
      const hasCreater = this.otherCreaterArr.filter(
        (item) => item.creatorId === this.chooseJoin.creatorId
      );
      if (this.chooseJoin && this.chooseJoin.nickname && !hasCreater.length) {
        this.otherCreaterArr.push({
          ...this.chooseJoin,
          role: "",
          isUser: this.user.userId === this.chooseJoin.creatorId,
        });
        this.chooseJoin = {};
      } else if (hasCreater.length) {
        this.$message.error(this.$t("global.共同创作者已存在"));
        this.chooseJoin = {};
      }
    },
    getLen(item, index) {
      const reg = /[^\x00-\xff]/g;

      let len = item.role && item.role.length;
      if (reg.test(item.role)) {
        len += item.role.match(reg) && item.role.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 8) {
        item.max = len;
      }
      return roleLen || 0;
    },
    getTitleLiength() {
      const reg = /[^\x00-\xff]/g;
      let len = this.title && this.title.length;
      if (reg.test(this.title)) {
        len += this.title.match(reg) && this.title.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 40) {
        this.titleLength = len;
      }
      return roleLen || 0;
    },
    getEnTitleLiength() {
      const reg = /[^\x00-\xff]/g;
      let len = this.enTitle && this.enTitle.length;
      if (reg.test(this.enTitle)) {
        len += this.enTitle.match(reg) && this.enTitle.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 40) {
        this.enTitleLength = len;
      }
      return roleLen || 0;
    },
    selectCategory() {
      this.showTypeBox = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.showTypeBox = false;
      document.body.style.overflow = "";
    },
    reUploadF() {
      this.$refs.cropComponent.reUpload("10size");
    },
    updateImage(img) {
      let $this = this;
      this.thumb = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(this.thumb, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 10) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 10MB!`);
      //   return;
      // }
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.thumb = res.key;
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", imgFile);
      // param.append("fileNames", "thumb");

      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     this.$message({
      //       message: response.message,
      //       type: "success",
      //     });
      //     this.thumb = response.data.thumb.key;
      //   });
    },
    reUpload() {
      document.querySelector(".upInput").click();
    },
    goBack() {
      this.$router.go(-1);
    },
    removeFormat(name) {
      let val = name.lastIndexOf(".");
      if (val != -1) {
        return name.substr(0, val);
      } else {
        return name;
      }
    },

    saveIndustry(type) {
      let url = "/api/other/createTag";
      let form = {};
      let $this = this;
      form["type"] = type;
      switch (type) {
        case 1:
          form["name"] = this.newIndustry;
          if (this.newIndustry == "") {
            this.$message(this.$t("global.新增行业不能为空"));
            return;
          }
          break;
        case 2:
          form["name"] = this.newProfession;
          if (this.newProfession == "") {
            this.$message(this.$t("global.新增专业不能为空"));
            return;
          }
          break;
        case 3:
          form["name"] = this.newHot;
          if (this.newHot == "") {
            this.$message(this.$t("global.新增其他标签不能为空"));
            return;
          }
          break;
        case 4:
          form["name"] = this.newEquipment;
          if (this.newEquipment == "") {
            this.$message(this.$t("global.新增工作设置不能为空"));
            return;
          }
          break;
      }
      this.$http.post(url, form).then((response) => {
        if (response.code == "OK") {
          let tagD = response.data;
          let newTag = {};
          if (tagD != null) {
            newTag["title"] = tagD.title;
            newTag["type"] = "other";
            newTag["categoryId"] = tagD.id + "_other";
            if (type == 1) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.industryList,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.industryList.push(newTag);
                $this.industryIds.push(newTag.categoryId);
                $this.newIndustry = "";
                $this.addIndustry = false;
              }
            } else if (type == 2) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.professionList,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.professionList.push(newTag);
                $this.professionIds.push(newTag.categoryId);
                $this.newProfession = "";
                $this.addProfession = false;
              }
            } else if (type == 3) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.hotTagList,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.hotTagList.push(newTag);
                $this.hotIds.push(newTag.title);
                $this.newHot = "";
                $this.addHot = false;
              }
            } else if (type == 4) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.equipment,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.equipment.push(newTag);
                $this.equipmentIds.push(newTag.title);
                $this.newEquipment = "";
                $this.addEquipment = false;
              }
            }
          }
        }
      });
    },
    changeEquipmentIds(id) {
      let index = this.equipmentIds.indexOf(id);
      if (index == -1) {
        this.equipmentIds.push(id);
      } else {
        this.equipmentIds.splice(index, 1);
      }
    },
    changeCategoryIds(id) {
      this.matchCategoryIds.splice(0, 1, id);
      this.categoryId = id;
    },
    changeHotIds(id) {
      let index = this.hotIds.indexOf(id);
      if (index == -1) {
        this.hotIds.push(id);
      } else {
        this.hotIds.splice(index, 1);
      }
    },
    changeIndustryIds(item, value) {
      if (item.groupType !== 2) {
        this.isHidenAdd = false;
        this.tagId = item.id;
        this.subClassification = [];
        this.subClassification.push(item);
        let index = this.pointerTag.indexOf(item.id);
        if (index == -1) {
          this.selectTag({
            id: item.id,
            name: item.name,
            enName: item.enName,
            isCategoryAdd: item.isCategoryAdd,
          });
        }
        return;
      }
      let videoId = this.$query.videoId;
      let params = {};
      if (videoId) {
        params = {
          videoId: videoId,
        };
      }
      for (let y = 0; y < this.subClassifications.length; y++) {
        if (this.subClassifications[y].tagId == item.tagId) {
          this.subClassification = this.subClassifications[y].data;
          this.isHidenAdd = true;
          this.tagId = item.id;
          if (!value) {
            // let index = this.pointerTag.indexOf(item.id);
            // if (index == -1) {
            //   this.selectTag({
            //     id: item.tagId,
            //     name: item.name,
            //     enName: item.enName,
            //   });
            // }
            // this.isselectTags = this.selectTags;
          } else {
            for (let t = 0; t < this.subClassifications.length; t++) {
              for (let u = 0; u < this.subClassifications[t].data.length; u++) {
                for (let l = 0; l < value.tagIds.length; l++) {
                  if (
                    this.subClassifications[t].data[u].id == value.tagIds[l]
                  ) {
                    this.selectTag(
                      this.subClassifications[t].data[u],
                      value.groupId
                    );
                  }
                }
              }
            }
          }
          return;
        }
      }
      this.$http
        .get("/api/video/tag/category/child/" + item.tagId, { params })
        .then((response) => {
          this.subClassifications.push({
            tagId: item.tagId,
            data: response.data,
          });
          for (let i = 0; i < this.subClassifications.length; i++) {
            if (this.subClassifications[i].tagId == item.tagId) {
              this.subClassification = this.subClassifications[i].data;
            }
          }
          this.isHidenAdd = true;
          this.tagId = item.id;
          if (!value) {
            this.subClassification.unshift({
              id: item.tagId,
              name: item.name,
              enName: item.enName,
            });
            let index = this.pointerTag.indexOf(item.tagId);
            if (index == -1) {
              this.selectTag({
                id: item.tagId,
                name: item.name,
                enName: item.enName,
              });
            }
          } else {
            for (let t = 0; t < this.subClassifications.length; t++) {
              for (let u = 0; u < this.subClassifications[t].data.length; u++) {
                for (let l = 0; l < value.tagIds.length; l++) {
                  if (
                    this.subClassifications[t].data[u].id == value.tagIds[l]
                  ) {
                    this.selectTag(
                      this.subClassifications[t].data[u],
                      value.groupId
                    );
                    this.dinfTags();
                  }
                }
              }
            }
          }
        });
    },
    selectTag(item, groupId) {
      let index = this.pointerTag.indexOf(item.id);
      if (index == -1) {
        this.pointerTag.push(item.id);
        this.selectTags.push({ groupId: groupId || this.tagId, data: item });
        if (this.selectTags.length <= 5) {
          var data = [];
          data.push(item.id);
          this.videoTagsGroup.push({
            groupId: this.tagId,
            tagIds: data,
            isCategory: true,
            isCategoryAdd: item.isCategoryAdd,
          });
        }
      } else {
        this.pointerTag = this.pointerTag.filter((i) => {
          return i !== item.id;
        });
        this.selectTags = this.selectTags.filter((i) => {
          return i.data.id !== item.id;
        });

        for (var i = 0; i < this.videoTagsGroup.length; i++) {
          var tagIds = this.videoTagsGroup[i].tagIds;
          if (
            tagIds.includes(item.id) &&
            this.videoTagsGroup[i].groupId == (groupId || this.tagId)
          ) {
            tagIds.splice(
              tagIds.findIndex((i) => item.id === i),
              1
            );
          }
          this.videoTagsGroup[i].tagIds = tagIds;
          if (!tagIds.length) {
            this.videoTagsGroup.splice(i, 1);
          }
        }
      }
      for (var i = 0; i < this.videoTagsGroup.length; i++) {
        var times = 0;
        for (var j = 0; j < this.videoTagsGroup.length; j++) {
          if (
            this.videoTagsGroup[i].groupId === this.videoTagsGroup[j].groupId
          ) {
            this.videoTagsGroup[i].tagIds = [
              ...new Set([
                ...this.videoTagsGroup[i].tagIds,
                ...this.videoTagsGroup[j].tagIds,
              ]),
            ];
            if (times) {
              this.videoTagsGroup.splice(j--, 1);
              break;
            }
            times++;
          }
        }
      }
    },
    selectOtherTag(item, id, value) {
      let index1 = this.tags1Select.indexOf(item.id);
      let index2 = this.tags2Select.indexOf(item.id);
      let index3 = this.tags3Select.indexOf(item.id);
      let index4 = this.tags4Select.indexOf(item.id);
      let index5 = this.tags5Select.indexOf(item.id);
      let index6 = this.tags6Select.indexOf(item.id);
      let index7 = this.tags7Select.indexOf(item.id);
      if (value == 1) {
        if (index1 == -1) {
          if (this.tags1Select.length < 3) {
            this.tags1Select.push(item.id);
            var data = [];
            data.push(item.id);
            this.videoTagGroup.push({
              groupId: id,
              tagIds: data,
              isCategory: false,
            });
          } else {
            this.$message(this.$t("global.最多选择3个"));
          }
        } else {
          this.tags1Select = this.tags1Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      if (value == 2) {
        if (index2 == -1) {
          if (this.tags2Select.length < 3) {
            this.tags2Select.push(item.id);
            var data = [];
            data.push(item.id);
            this.videoTagGroup.push({
              groupId: id,
              tagIds: data,
              isCategory: false,
            });
          } else {
            this.$message(this.$t("global.最多选择3个"));
          }
        } else {
          this.tags2Select = this.tags2Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      if (value == 3) {
        if (index3 == -1) {
          this.tags3Select.push(item.id);
          var data = [];
          data.push(item.id);
          this.videoTagGroup.push({
            groupId: id,
            tagIds: data,
            isCategory: false,
          });
        } else {
          this.tags3Select = this.tags3Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      if (value == 4) {
        if (index4 == -1) {
          this.tags4Select.push(item.id);
          var data = [];
          data.push(item.id);
          this.videoTagGroup.push({
            groupId: id,
            tagIds: data,
            isCategory: false,
          });
        } else {
          this.tags4Select = this.tags4Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      if (value == 5) {
        if (index5 == -1) {
          this.tags5Select.push(item.id);
          var data = [];
          data.push(item.id);
          this.videoTagGroup.push({
            groupId: id,
            tagIds: data,
            isCategory: false,
          });
        } else {
          this.tags5Select = this.tags5Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      if (value == 6) {
        if (index6 == -1) {
          this.tags6Select.push(item.id);
          var data = [];
          data.push(item.id);
          this.videoTagGroup.push({
            groupId: id,
            tagIds: data,
            isCategory: false,
          });
        } else {
          this.tags6Select = this.tags6Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      if (value == 7) {
        if (index7 == -1) {
          this.tags7Select.push(item.id);
          var data = [];
          data.push(item.id);
          this.videoTagGroup.push({
            groupId: id,
            tagIds: data,
            isCategory: false,
          });
        } else {
          this.tags7Select = this.tags7Select.filter((i) => {
            return i !== item.id;
          });
          for (var i = 0; i < this.videoTagGroup.length; i++) {
            var tagIds = this.videoTagGroup[i].tagIds;
            if (
              tagIds.includes(item.id) &&
              this.videoTagGroup[i].groupId == id
            ) {
              tagIds.splice(
                tagIds.findIndex((i) => item.id === i),
                1
              );
            }
            this.videoTagGroup[i].tagIds = tagIds;
            if (!tagIds.length) {
              this.videoTagGroup.splice(i, 1);
            }
          }
        }
      }
      for (var i = 0; i < this.videoTagGroup.length; i++) {
        var times = 0;
        for (var j = 0; j < this.videoTagGroup.length; j++) {
          if (this.videoTagGroup[i].groupId === this.videoTagGroup[j].groupId) {
            this.videoTagGroup[i].tagIds = [
              ...new Set([
                ...this.videoTagGroup[i].tagIds,
                ...this.videoTagGroup[j].tagIds,
              ]),
            ];
            if (times) {
              this.videoTagGroup.splice(j--, 1);
              break;
            }
            times++;
          }
        }
      }
    },
    dinfTags() {
      this.isselectTags = [];
      for (let i = 0; i < this.selectTags.length; i++) {
        this.isselectTags.push(this.selectTags[i]);
      }
      this.showTypeBox = false;
      document.body.style.overflow = "";
    },
    dinfTags1() {
      for (let i = 0; i < this.selectTags.length; i++) {
        this.isselectTags.push(this.selectTags[i]);
      }
      for (let i = 0; i < this.isselectTags.length; i++) {
        var times = 0;
        for (let j = 0; j < this.isselectTags.length; j++) {
          if (this.isselectTags[i].groupId === this.isselectTags[j].groupId) {
            if (times) {
              this.isselectTags.splice(j--, 1);
              break;
            }
            times++;
          }
        }
      }

      this.showTypeBox = false;
      document.body.style.overflow = "";
    },
    openOneTag() {
      if (this.selectTags.length >= 5) {
        this.$message(this.$t("video.数量已达到上限，无法添加"));
        return;
      }
      this.oneTag = !this.oneTag;
    },
    addOneNewTag() {
      if (!this.oneNewTag.replace(/[\r\n\s]/g, "")) {
        this.$message(this.$t("global.不能为空"));
        return;
      }
      let form = {};
      if (this.language === "zh") {
        form["name"] = this.oneNewTag;
      } else {
        form["enName"] = this.oneNewTag;
      }

      this.$http.post("/api/video/tag/create", form).then((res) => {
        if (res.code == "OK") {
          let data = res.data;
          let obj = {
            enName: data.enName,
            id: data.id,
            isAdd: true,
            name: data.name,
            sort: null,
            isCategoryAdd: true,
          };
          this.tagId = obj.id;
          this.selectTag(obj);
          this.tagsClassification.push(obj);
          this.subClassification = [];
          this.subClassification.push(obj);
          this.isHidenAdd = false;
          this.oneTag = false;
          this.oneNewTag = "";
        }
      });
    },
    openAddNewTag() {
      if (this.selectTags.length >= 5) {
        this.$message(this.$t("video.数量已达到上限，无法添加"));
        return;
      }
      this.secondTag = !this.secondTag;
    },
    addNewTag() {
      if (!this.newTag.replace(/[\r\n\s]/g, "")) {
        this.$message(this.$t("global.不能为空"));
        return;
      }
      let form = {};
      if (this.language === "zh") {
        form["name"] = this.newTag;
      } else {
        form["enName"] = this.newTag;
      }

      this.$http.post("/api/video/tag/create", form).then((res) => {
        if (res.code == "OK") {
          let data = res.data;
          let obj = {
            enName: data.enName,
            id: data.id,
            isAdd: true,
            name: data.name,
            sort: null,
          };
          this.selectTag(obj);
          this.subClassification.push(obj);
          this.secondTag = false;
          this.newTag = "";
        }
      });
    },
    openAddIndustry() {
      if (this.tags1Select.length >= 3) {
        this.$message(this.$t("video.数量已达到上限，无法添加"));
        return;
      }
      this.addIndustry = true;
    },
    openAddApplication() {
      if (this.tags2Select.length >= 3) {
        this.$message(this.$t("video.数量已达到上限，无法添加"));
        return;
      }
      this.addApplication = true;
    },
    addNewTagOther(type, id) {
      let form = {};
      switch (type) {
        case 1:
          if (!this.newIndustry.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newIndustry;
          } else {
            form["enName"] = this.newIndustry;
          }
          break;
        case 2:
          if (!this.newApplication.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newApplication;
          } else {
            form["enName"] = this.newApplication;
          }
          break;
        case 3:
          if (!this.newHot.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newHot;
          } else {
            form["enName"] = this.newHot;
          }
          break;
        case 4:
          if (!this.newSoftware.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newSoftware;
          } else {
            form["enName"] = this.newSoftware;
          }
          break;
        case 5:
          if (!this.newHardware.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newHardware;
          } else {
            form["enName"] = this.newHardware;
          }
          break;
        case 6:
          if (!this.newStuff.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newStuff;
          } else {
            form["enName"] = this.newStuff;
          }
          break;
        case 7:
          if (!this.newTool.replace(/[\r\n\s]/g, "")) {
            this.$message(this.$t("video.新增标签不能为空"));
            return;
          }
          if (this.language === "zh") {
            form["name"] = this.newTool;
          } else {
            form["enName"] = this.newTool;
          }
          break;
      }
      this.$http.post("/api/video/tag/create", form).then((res) => {
        if (res.code == "OK") {
          let data = res.data;
          let obj = {
            enName: data.enName,
            id: data.id,
            isAdd: true,
            name: data.name,
            sort: null,
          };
          this.selectOtherTag(obj, id, type);
          switch (type) {
            case 1:
              this.tags1.tagEditFroms.push(obj);
              this.addIndustry = false;
              this.newIndustry = "";
              break;
            case 2:
              this.tags2.tagEditFroms.push(obj);
              this.addApplication = false;
              this.newApplication = "";
              break;
            case 3:
              this.tags3.tagEditFroms.push(obj);
              this.addHot = false;
              this.newHot = "";
              break;
            case 4:
              this.tags4.tagEditFroms.push(obj);
              this.addSoftware = false;
              this.newSoftware = "";
              break;
            case 5:
              this.tags5.tagEditFroms.push(obj);
              this.addHardware = false;
              this.newHardware = "";
              break;
            case 6:
              this.tags6.tagEditFroms.push(obj);
              this.addStuff = false;
              this.newStuff = "";
              break;
            case 7:
              this.tags7.tagEditFroms.push(obj);
              this.addTool = false;
              this.newTool = "";
              break;
          }
        }
      });
    },
    amountNumber(id) {
      let amount = null;
      for (let i = 0; i < this.videoTagsGroup.length; i++) {
        if (this.videoTagsGroup[i].groupId == id) {
          amount = this.videoTagsGroup[i].tagIds.length;
        }
      }
      return amount;
    },
    changeProfessionIds(id) {
      let index = this.professionIds.indexOf(id);
      if (index == -1) {
        this.professionIds.push(id);
      } else {
        this.professionIds.splice(index, 1);
      }
    },
    isSelectOne(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    isSelect(item) {
      let index = this.equipmentIds.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    searchUser(query) {
      if (query !== "") {
        this.get_searchUser(query);
      } else {
        this.fanlist = [];
      }
    },
    deteleHtml(html) {
      let reg = /(<\/?em.*?>)/gi;
      return html.replace(reg, "");
    },
    get_searchUser(query) {
      const _this = this;
      const params = {
        isCertification: undefined,
        keyword: query || undefined,
        initial: undefined,
        city: undefined,
        type: 2,
        pageIndex: 1,
        pageSize: 50,
      };
      this.$http
        .post("/api/search/list2", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (
            response.data &&
            response.data.pageList &&
            response.data.pageList.list
          ) {
            const userList = filter_user(response.data.pageList.list);
            _this.fanlist = userList;
          }
        });
      function filter_user(list) {
        let userList = [];
        for (let i = 0; i < list.length; i++) {
          const el = list[i];
          const userDetail = {
            avatar: el.avatar,
            creatorId: el.userId,
            nickname: el.nickname,
          };
          userList.push(userDetail);
        }
        return userList;
      }
    },
    hotTagListF() {
      this.$http.get("/api/common/hotTagList").then((res) => {
        if (res.code === "OK") {
          res.data.map((item) => {
            const flag = this.hotTagList.find(
              (item1) => item1.title === item.title
            );
            if (!flag) {
              this.hotTagList.push(item);
            }
          });
        }
      });
    },
    getEquipmentList() {
      this.$http
        .get("/api/other/tagListOrTag", { params: { type: 5 } })
        .then((res) => {
          if (res.code === "OK") {
            res.data.map((item) => {
              const flag = this.equipment.find(
                (item1) => item1.title === item.title
              );
              if (!flag) {
                this.equipment.push(item);
              }
            });
          }
        });
    },
    categoryList() {
      this.$http.get("/api/common/categoryList").then((response) => {
        this.industryList = response.data.industryList;
        this.professionList = response.data.professionList;
      });
    },
    tagList() {
      let videoId = this.$query.videoId;
      let params = {};
      if (videoId) {
        params = {
          videoId: videoId,
        };
      }
      this.$http.get("/api/video/tag/category", { params }).then((response) => {
        this.tagsClassification = response.data;
      });
    },
    changeIndex(index) {
      this.contentIndex = index;
    },
    upImgClick(index) {
      this.$store.dispatch("setImgIndex", index);
      if (index === 1) {
        document.querySelector(".upInputIMG").click();
      } else {
        document.querySelector(".upInputIMG1").click();
      }
    },
    chagneOriginal(val) {
      this.isOriginal = val;
    },
    deleteOtherCreater(index) {
      this.otherCreaterArr.splice(index, 1);
    },
    upImg(e) {
      if (e.target.files[0].size / 1024 / 1024 > 3) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return;
      }
      let param = new FormData();
      param.append("files", e.target.files[0]);
      this.$http
        .post("/api/common/upload/image", param, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          switch (this.$store.state.imgIndex) {
            case 1:
              this.thumb = response.data;
              break;
            case 2:
              this.images.push(response.data);
              break;
          }
        });
    },
    getImgTwo() {
      this.$refs.bannerCropper.getCropData((data) => {
        this.bannerImgBase = data;
        this.stepForm.banner = data;
        this.bannerState = false;
        document.documentElement.style.overflowY = "scroll";
        this.fileUp = true;
      });
    },

    upImg1(e) {
      let $this = this;
      if (e.target.files[0].size / 1024 / 1024 > 3) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return;
      }
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        switch ($this.$store.state.imgIndex) {
          case 1:
            $this.thumb = res.key;
            break;
          case 2:
            $this.images.push(res.key);
            break;
        }
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: e.target.files[0].name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", e.target.files[0]);
      // this.$http
      //   .post("/api/common/upload/image", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     this.$message({
      //       message: response.message,
      //       type: "success",
      //     });
      //     switch (this.$store.state.imgIndex) {
      //       case 1:
      //         this.thumb = response.data;
      //         break;
      //       case 2:
      //         this.images.push(response.data);
      //         break;
      //     }
      //   });
    },

    getOtherCreator() {
      let config = {
        loading: false,
      };
      this.$http.get("/api/u/video/otherCreator", config).then((response) => {
        this.fanlist = response.data;
      });
    },
    testValue(envent, valueS) {
      let reg = /\S/;
      if (this.isUploading) {
        this.$message.error(this.$t("global.视频上传中"));
        return false;
      }
      if (!this.isUploadSuccess) {
        this.$message.error(this.$t("global.视频上传失败"));
        return false;
      }
      if (!this.title) {
        this.$message.error(this.$t("global.视频名称不能为空"));
        document.getElementById("view1").scrollIntoView(true);
        return false;
      }
      // if (!this.enTitle && this.isInternational) {
      //   this.$message.error(this.$t("global.视频名称英文不能为空"));
      //   return false;
      // }
      if (!this.isOriginal) {
        this.$message.error(this.$t("global.请选择是否原创"));
        return false;
      }
      if (!this.creationYear) {
        this.$message.error(this.$t("video.请选择创作年份"));
        document.getElementById("view2").scrollIntoView(true);
        return false;
      }
      if (!this.textTer) {
        if (!this.introduction) {
          this.$message.error(this.$t("video.作品介绍不能为空"));
          document.getElementById("view3").scrollIntoView(true);
          return false;
        }
      } else {
        if (!this.introductionText) {
          this.$message.error(this.$t("video.作品介绍不能为空"));
          document.getElementById("view3").scrollIntoView(true);
          return false;
        }
      }
      if (!this.thumb) {
        this.$message.error(this.$t("global.请上传作品封面"));
        return false;
      }
      // if (this.industryIds.length === 0) {
      //   this.$message.error(this.$t("global.请选择行业"));
      //   return false;
      // }
      // if (this.professionIds.length === 0) {
      //   this.$message.error(this.$t("global.请选择专业"));
      //   return false;
      // }
      if (!this.allowDownload) {
        this.$message.error(this.$t("global.请选择是否允许被下载"));
        return false;
      }
      return true;
    },
    submit() {
      // let testResult = this.testValue();
      // if (!testResult) return;
      // let industryObj = this.$jsonUtils.getListExitsVal(
      //   this.industryIds,
      //   "_other"
      // );
      // let professionObj = this.$jsonUtils.getListExitsVal(
      //   this.professionIds,
      //   "_other"
      // );
      let showConditions = [];
      if (this.door1) {
        showConditions.push(1);
      }
      if (this.door2) {
        showConditions.push(2);
      }
      if (this.door3) {
        showConditions.push(3);
      }
      this.businessForm = {
        id: this.businessFormId,
        showConditions: showConditions.join(),
        leasePriceType: this.leaseValue,
        leaseCustomPrice: this.leasePrice,
        salePriceType: this.saleValue,
        saleCustomPrice: this.salePrice,
        customizationPriceType: this.customizedValue,
        customizationCustomPrice: this.customizedPrice,
        other: this.otherPrice,
      };
      const queryObj = {
        // videoIntroduction: this.tinymceHtml,
        // creatorIds: this.otherCreaterArr.map((item) => item.creatorId).join(),
        creatorIds: this.otherCreaterArr.map((item) =>
          item.creatorId.toString()
        ),
        creatorJson: JSON.stringify(this.otherCreaterArr),
        videoId: this.videoId,
        title: this.title,
        enTitle: this.enTitle,
        enIntroduction: this.enIntroduction,
        introduction: this.introduction,
        introductionText: this.introductionText,
        enIntroductionText: this.enIntroductionText,
        thumb: this.thumb,
        images: this.images.join(),
        isOriginal: this.isOriginal,
        isPub: this.isPub,
        // equipment: this.equipment.join(),
        hash: this.hash,
        key: this.key,
        videoWidth: this.videoWidth,
        videoHeight: this.videoHeight,
        activityId: this.activityId,
        status: 1,
        brand: this.brand,
        creationYear: this.creationYear,
        creationMonth: this.creationMonth,
        // industryIds: industryObj.notInList,
        // professionIds: professionObj.notInList,
        fileName: this.fileName,
        thumbs: this.thumbs.join(),
        // equipment: this.equipmentIds.join(),
        // tags: this.hotIds.join(),
        // otherIndustryIds: this.$jsonUtils.replaceAll(
        //   industryObj.inList.join(),
        //   "_other"
        // ),
        // otherProfessionIds: this.$jsonUtils.replaceAll(
        //   professionObj.inList.join(),
        //   "_other"
        // ),
        allowDownload: this.allowDownload,
        // matchCategoryIds: this.matchCategoryIds,
        // businessForm: JSON.stringify(this.businessForm),
        // videoTagGroup: JSON.stringify(this.videoTagGroup)
        businessForm: this.businessForm,
        videoTagGroup: this.videoTagGroup,
        editStatus: this.textTer ? 1 : 2,
      };
      if (this.key && this.language !== "zh") {
        if (this.key.indexOf("upload") > -1) {
          queryObj.key = `https://videos.manamana.net` + this.key;
        }
        queryObj.persistentId = this.key;
        queryObj.duration = this.duration;
        queryObj.isTransform = false;
      }
      let url;
      if (this.videoId) {
        url = "/api/u/video/update2";
      } else {
        url = "/api/u/video/create2";
        queryObj.source = "pc";
      }
      if (this.submitFlag) {
        this.submitFlag = false;
        let queryJson = JSON.parse(JSON.stringify(queryObj));
        this.$http
          .post(url, queryObj, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.code === "OK") {
              if (!this.videoId) {
                this.videoId = response.data;
              }
              this.isOkOpen = true;
              this.submitFlag = true;
              this.$router.push(`/videoSuccess/${this.videoId}`);
            }
          })
          .catch((err) => {
            this.submitFlag = true;
          });
      }
    },
    firstSubmit() {
      let testResult = this.testValue();
      if (!testResult) return;
      this.firstStep = true;
      this.step = 2;
      this.$nextTick(() => {
        document.getElementById("stepStatus").scrollIntoView(true);
      });
    },
    twoSubmit() {
      if (this.videoTagsGroup.length == 0) {
        this.$message.error(this.$t("video.请选择类别"));
        document.getElementById("view4").scrollIntoView(true);
        return;
      }
      for (let i = 0; i < this.videoTagsGroup.length; i++) {
        this.videoTagGroup.push(this.videoTagsGroup[i]);
      }
      for (var i = 0; i < this.videoTagGroup.length; i++) {
        var times = 0;
        for (var j = 0; j < this.videoTagGroup.length; j++) {
          if (this.videoTagGroup[i].groupId === this.videoTagGroup[j].groupId) {
            this.videoTagGroup[i].tagIds = [
              ...new Set([
                ...this.videoTagGroup[i].tagIds,
                ...this.videoTagGroup[j].tagIds,
              ]),
            ];
            if (times) {
              this.videoTagGroup.splice(j--, 1);
              break;
            }
            times++;
          }
        }
      }
      this.twoStep = true;
      this.step = 3;
      this.$nextTick(() => {
        document.getElementById("stepStatus").scrollIntoView(true);
      });
    },
    detail(id) {
      this.isFirst = false;
      setTimeout(() => {
        this.$refs.progress.style.width = "100%";
      }, 0);
      let $this = this;
      this.$http.get("/api/u/video/detail/" + id).then((response) => {
        if (response.data && response.code === "OK") {
          let data = response.data;
          this.enTitle = data.enTitle || "";
          this.enIntroduction = data.enIntroduction || "";
          this.hotIds = data.tagList;
          this.title = data.title;
          this.introduction = data.introduction;
          this.thumb = data.thumb;
          this.images = data.images != "" ? data.images.split(",") : [];
          this.allowDownload = data.allowDownload || 2;
          this.hash = data.hash;
          this.activityId = data.id;
          this.industryIds = data.industryIdList;
          this.professionIds = data.professionIdList;
          this.isPub = data.isPub;
          if (data.editStatus == 1) {
            this.textTer = true;
          } else if (data.editStatus == 2) {
            this.textTer = false;
          }
          // this.key = data.filePath;
          this.fileName = data.fileName;
          this.uploadMessage = this.$t("global.上传成功");
          this.brand = data.brand;
          this.creationYear = data.creationYear;
          this.creationMonth = data.creationMonth;
          this.introductionText = data.introductionText || "";
          this.enIntroductionText = data.enIntroductionText || "";
          this.thumbs = data.thumbs != "" ? data.thumbs.split(",") : [];
          this.equipmentIds =
            data.equipment != "" ? data.equipment.split(",") : [];
          $this.isOriginal = String(data.isOriginal);

          if (data.videoBusinessDomain != null) {
            this.businessFormId = data.videoBusinessDomain.id;
            this.leaseValue = data.videoBusinessDomain.leasePriceType;
            this.leasePrice = data.videoBusinessDomain.leaseCustomPrice;
            this.saleValue = data.videoBusinessDomain.salePriceType;
            this.salePrice = data.videoBusinessDomain.saleCustomPrice;
            this.customizedValue =
              data.videoBusinessDomain.customizationPriceType;
            this.customizedPrice =
              data.videoBusinessDomain.customizationCustomPrice;
            this.otherPrice = data.videoBusinessDomain.other;
            if (this.leaseValue || this.leasePrice) {
              this.lease = true;
            }
            if (this.saleValue || this.salePrice) {
              this.sale = true;
            }
            if (this.customizedValue || this.customizedPrice) {
              this.customized = true;
            }
            if (this.otherPrice) {
              this.other = true;
            }
            if (data.videoBusinessDomain.showConditions) {
              if (data.videoBusinessDomain.showConditions.indexOf("1") !== -1) {
                this.door1 = true;
              }
              if (data.videoBusinessDomain.showConditions.indexOf("2") !== -1) {
                this.door2 = true;
              }
              if (data.videoBusinessDomain.showConditions.indexOf("3") !== -1) {
                this.door3 = true;
              }
            }
          }
          if (data.videoTagFrontForms != null) {
            for (let i = 0; i < data.videoTagFrontForms.length; i++) {
              if (data.videoTagFrontForms[i].isCategory) {
                for (let w = 0; w < this.tagsClassification.length; w++) {
                  if (
                    this.tagsClassification[w].id ==
                    data.videoTagFrontForms[i].groupId
                  ) {
                    if (data.videoTagFrontForms[i].isCategoryAdd) {
                      this.tagsClassification[w].isCategoryAdd = true;
                    }
                    this.changeIndustryIds(
                      this.tagsClassification[w],
                      data.videoTagFrontForms[i]
                    );
                    this.dinfTags();
                  }
                }

                // for (let y = 0; y < this.subClassifications.length; y++) {
                //   if (this.subClassifications[y].tagId == item.tagId) {
                //     this.subClassification = this.subClassifications[y].data;
                //     return;
                //   }
                // }
                // this.$http
                //   .get("/api/video/tag/category/child/" + data.videoTagFrontForms[i].groupId)
                //   .then((response) => {
                //     this.subClassifications.push({
                //       tagId: item.tagId,
                //       data: response.data,
                //     });
                //     for (let i = 0; i < this.subClassifications.length; i++) {
                //       if (this.subClassifications[i].tagId == item.tagId) {
                //         this.subClassification = this.subClassifications[
                //           i
                //         ].data;
                //       }
                //     }
                //     this.subClassification.unshift(item);

                //   });
              } else {
                for (let y = 0; y < this.otherTags.length; y++) {
                  if (
                    data.videoTagFrontForms[i].groupId == this.otherTags[y].id
                  ) {
                    if (this.otherTags[y].id == "11") {
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          1
                        );
                      }
                    }
                    if (this.otherTags[y].id == "14") {
                      //  this.selectOtherTag(data.videoTagFrontForms[i])
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          2
                        );
                      }
                    }
                    if (this.otherTags[y].id == "15") {
                      //  this.selectOtherTag(data.videoTagFrontForms[i])
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          3
                        );
                      }
                    }
                    if (this.otherTags[y].id == "16") {
                      //  this.selectOtherTag(data.videoTagFrontForms[i])
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          4
                        );
                      }
                    }
                    if (this.otherTags[y].id == "17") {
                      //  this.selectOtherTag(data.videoTagFrontForms[i])
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          5
                        );
                      }
                    }
                    if (this.otherTags[y].id == "18") {
                      //  this.selectOtherTag(data.videoTagFrontForms[i])
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          6
                        );
                      }
                    }
                    if (this.otherTags[y].id == "19") {
                      //  this.selectOtherTag(data.videoTagFrontForms[i])
                      for (
                        let z = 0;
                        z < data.videoTagFrontForms[i].tagIds.length;
                        z++
                      ) {
                        this.selectOtherTag(
                          { id: data.videoTagFrontForms[i].tagIds[z] },
                          data.videoTagFrontForms[i].groupId,
                          7
                        );
                      }
                    }
                  }
                }
              }
            }
          }

          if (data.otherIndustryList != null) {
            for (var i = 0, n = data.otherIndustryList.length; i < n; i++) {
              let aa = data.otherIndustryList[i];
              aa["categoryId"] = aa.id + "_other";
              this.industryList.push(aa);
              $this.industryIds.push(aa.id + "_other");
            }
          }

          if (data.otherProfessionList != null) {
            for (var i = 0, n = data.otherProfessionList.length; i < n; i++) {
              let aa = data.otherProfessionList[i];
              aa["categoryId"] = aa.id + "_other";
              this.professionList.push(aa);
              $this.professionIds.push(aa.id + "_other");
            }
          }

          if (data.otherHotTagList != null) {
            for (var i = 0, n = data.otherHotTagList.length; i < n; i++) {
              let aa = data.otherHotTagList[i];
              const flag = this.hotTagList.find(
                (item) => item.title === aa.title
              );
              if (!flag) {
                this.hotTagList.push(aa);
              }
              this.hotIds.push(aa.title);
            }
          }

          if (data.otherEquipmentList != null) {
            for (var i = 0, n = data.otherEquipmentList.length; i < n; i++) {
              let aa = data.otherEquipmentList[i];
              const flag = this.equipment.find(
                (item) => item.title === aa.title
              );
              if (!flag) {
                this.equipment.push(aa);
              }
              this.equipmentIds.push(aa.title);
            }
          }
          const creatorJson =
            (data.creatorJson && JSON.parse(data.creatorJson)) || [];
          this.otherCreaterArr =
            data.creatorList.map((item, index) => {
              return {
                ...creatorJson[index],
                avatar: item.avatar,
                nickname: item.nickName,
              };
            }) || [];
        }
      });
    },
    getOtherTags() {
      let videoId = this.$query.videoId;
      let params = {};
      if (videoId) {
        params = {
          videoId: videoId,
        };
      }
      this.$http.get("/api/video/tag/group", { params }).then((response) => {
        this.otherTags = response.data;
        for (let i = 0; i < this.otherTags.length; i++) {
          if (this.otherTags[i].id == "11") {
            this.tags1 = this.otherTags[i];
          }
          if (this.otherTags[i].id == "14") {
            this.tags2 = this.otherTags[i];
          }
          if (this.otherTags[i].id == "15") {
            this.tags3 = this.otherTags[i];
          }
          if (this.otherTags[i].id == "16") {
            this.tags4 = this.otherTags[i];
          }
          if (this.otherTags[i].id == "17") {
            this.tags5 = this.otherTags[i];
          }
          if (this.otherTags[i].id == "18") {
            this.tags6 = this.otherTags[i];
          }
          if (this.otherTags[i].id == "19") {
            this.tags7 = this.otherTags[i];
          }
        }
      });
    },
    hideAddInput() {
      this.addIndustry = false;
      this.addApplication = false;
      this.addHot = false;
      this.addSoftware = false;
      this.addHardware = false;
      this.addStuff = false;
      this.addTool = false;
    },
    gotoTwo() {
      if (this.firstStep) {
        this.step = 2;
      } else {
        this.$message.error(this.$t("video.请先完善基本信息"));
      }
    },
    gotoThree() {
      if (this.twoStep) {
        this.step = 3;
      } else {
        this.$message.error(this.$t("video.请先完善前面步骤"));
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    next(false);
    if (!this.isFirst && !this.isOkOpen) {
      // 这里需要elementui的支持，如果使用其他界面组件自行替换即可
      this.$confirm(
        this.$t("video.您所填写的信息尚未保存"),
        this.$t("video.确定要离开吗？"),
        {
          confirmButtonText: this.$t("video.确定"),
          cancelButtonText: this.$t("video.取消"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          // 正常跳转
          next();
        })
        .catch(() => {
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          window.history.go(1)
        });
    } else {
      next();
    }
  },
};
</script>
<style lang="stylus">
.el-message-box {
  // width: 400px;
}

.el-input__inner {
  border-radius: 0;
}

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: rgba(32, 38, 204, 1);
  border-color: rgba(32, 38, 204, 1);
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #666;
  font-size: 14px;
  font-weight: 400px;

  span {
    color: #2026CC;
  }
}

.watermark_sample {
  width: 960px;
  height: 540px;

  video {
    width: 100%;
    border-radius: 10px;
  }
}

.show_watermark_sample {
  color: #2026CC;
}

.containerUpVideo {
  .upVideo .el-input__inner {
    width: 227px;
    height: 40px;
    // margin-top: 0.1rem;
    background-color: #f3f3f3;
    // border-radius: 5px;
    text-indent: 0.1rem;
    outline: none;
    border: none;
    border: 1px solid rgba(224, 224, 224, 1);
    background: #fff;
    // background: url('/static/uploadvideo/selarrorw.png') no-repeat 95% center;
    background-size: 13px 6px;
    color: #666;
  }

  .customPrice2 {
    width: auto;
  }

  .customPrice2 .el-input__inner {
    vertical-align: top;
    margin-left: 12px;
    padding-left: 15px;
    width: 270px;
    height: 40px;
    box-sizing: border-box;
    border: 1px solid rgba(224, 224, 224, 1);

    &:focus {
      border: 1px solid rgba(32, 38, 204, 0.85);
    }
  }

  .customPrice1 {
    width: 510px;
  }

  .customPrice1 .el-input__inner {
    vertical-align: top;
    margin-left: 10px;
    padding-left: 15px;
    width: 510px;
    height: 40px;
    box-sizing: border-box;
    border: 1px solid rgba(224, 224, 224, 1);

    &:focus {
      border: 1px solid rgba(32, 38, 204, 0.85);
    }
  }

  .upVideo .role .el-input__inner {
    background: none;
  }

  .upVideo .drap .el-tree-node {
    height: 62px;
    line-height: 62px;
    background: rgba(0, 0, 0, 0);
    cursor: pointer;
  }

  .upVideo .drap .el-tree-node .el-tree-node__content {
    line-height: 60px;
    display: inline-block;
  }

  .upVideo .drap .el-tree-node .el-tree-node__content:hover {
    background: none;
  }

  .upVideo .drap .el-tree-node .el-tree-node__content .el-tree-node__expand-icon {
    display: none;
  }

  .phonenum .el-input--suffix {
    float: left;
    height: 50px;
  }

  .phonenum .leftside .el-input__inner {
    width: 76px;
    padding: 0 5px 0 0;
    border: none;
    outline: none;
    margin-top: 0;
    height: 50px;
    line-height: 50px;
    text-indent: 0;
    font-size: 16px;
    cursor: text;
  }

  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #cecece;
  }

  input:-moz-placeholder, textarea:-moz-placeholder {
    color: #cecece;
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: #cecece;
  }

  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #cecece;
  }

  .el-checkbox {
    min-width: 1.5rem;
    margin-right: 0.4rem;
  }

  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
}

.step2-fanHead {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  width: 100%;
}

.containerUpVideo {
  background: #fff;
  min-height: calc(100vh - 210px);

  .videoupload {
    font-size: 12px;
    margin-bottom: 32px;
    color: rgba(153, 153, 153, 1);
  }

  .contain {
    padding-top: 66px;
    margin-top: -66px;
    .left {
      margin: 40px 0 20px;
    }

    .right {
      span {
        color: #999;
        font-size: 12px;
        display: block;
        line-height: 25px;
        margin-bottom: 10px;

        b {
          color: #D0021B;
        }
      }

      &.female {
        span {
          line-height: 18px;

          b {
            color: #333;
          }
        }
      }
    }
  }

  .videoupload b {
    font-size: 20px;
    color: rgba(0, 0, 0, 1);
    margin-right: 8px;
  }

  .onloadings {
    position: relative;
    overflow: hidden;
  }

  .onloadings .video-box {
    width: 100%;
    height: 199px;
    background: rgba(10, 10, 10, 1);
    position: relative;
  }

  .onloadings .file-Name {
    font-size: 16px;
    margin-top: 15px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .onloadings .progressNumber {
    margin: 10px 0 15px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .onloadings .againUpload {
    width: 110px;
    height: 38px;
    background: rgba(245, 245, 245, 1);
    font-size: 14px;
    font-weight: 500;
    color: rgba(184, 184, 184, 1);
    text-align: center;
    line-height: 38px;
    cursor: pointer;
  }

  .onloadings .againUploadSuccess {
    color: #2026CC;
  }

  .onloadings .againUpload .againImg {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 4px;
  }

  .onloadings .video-box p {
    font-size: 16px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
  }

  // .onloadings>div {
  // position: absolute;
  // top: 0;
  // left: 55px;
  // width: 608.59px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // }

  // .onloadings .right {
  // top: 15px;
  // }

  // .onloadings .videoed {
  // display: inline-block;
  // float: left;
  // width: 35px;
  // height: 46px;
  // margin-right: 20px;
  // }

  // .onloadings .videoed img {
  // float: left;
  // width: 35px;
  // height: 22px;
  // margin-top: 22px;
  // }
  .coverpic {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    margin-top: 32px;
  }

  .coverpic span {
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
    margin-right: 8px;
  }

  .required {
    position: relative;
    top: 3px;
    width: 10px;
    height: 12px;
    color: red;
    font-size: 18px;
    margin-right: 5px;
  }

  .randomtopic {
    overflow: hidden;
  }

  .randomtopic .onrandom {
    float: left;
    width: calc(100% - 210px);
    overflow: hidden;
  }

  .randomtopic .onrandom div {
    float: left;
    width: 116px;
    height: 67px;
    // border-radius: 5px;
    margin-right: 10px;
    cursor: pointer;
    background-color: #f0f0f0;
    background-size: 100% 100%;
    box-sizing: border-box;
  }

  .dalayloading div.active {
    border: 2px solid #0579ff;
  }

  .randomtopic .onrandom .defaults {
    float: left;
    width: 100%;
    font-size: 12px;
    color: #999;
    margin: 15px 0 12px 0;
  }

  .containerSwcond {
    .basic-wrap {
      .uploadwidth {
        position: relative;
        float: left;
        width: 105px;
        height: 105px;
        padding: 0;
        cursor: pointer;
        // margin: 20px 15px 0 0;
        background-size: 100% 100%;
        background-color: #F4F5F7;

        .add-wrap {
          width: 194px;
          height: 109px;
          margin: 0;
          border: none;

          .font {
            padding: 0;

            span {
              color: #fff;
              display: inline-block;
              margin: 0;
            }
          }
        }

        .font {
          padding: 0;

          span {
            color: #fff;
            display: inline-block;
            margin: 0;
          }
        }
      }

      .uploadwidth1 {
        width: 190px;
        height: 109px;
      }

      .clickloads {
        // margin: 0 15px 0 0;
      }
    }
  }

  .uploadwidth .upFont {
    position: relative;
    float: right;
    margin-top: -30px;
    width: 84px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .uploadwidth .font span:first-child {
    position: absolute;
    top: 0;
    width: 55px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    left: 0;
    z-index: 10;
  }

  .uploadwidth .font span:last-child {
    position: absolute;
    display: inline-block;
    width: 55px;
    height: 22px;
    line-height: 22px;
    top: 0;
    left: 0;
    z-index: 9;
    opacity: 0.6;
    border-radius: 3px;
    background-color: #000;
  }

  .dalayloading {
    position: relative;
    // border-radius: 5px;
  }

  .dalayloading img {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 50%;
    left: 50%;
    margin: -12px 0 0 -12px;
  }

  .containtitle .font {
    color: #333;
    font-size: 16px;
    font-weight: 500;
  }

  .containtitle .usertype {
    width: 100%;
    height: 40px;
    padding: 0 70px 0 10px;
    border: 1px solid rgba(224, 224, 224, 1);
    box-sizing: border-box;
  }

  .containtitle .textType {
    margin: 20px 0 17px 0;
    font-size: 0;
  }

  .containtitle .textType span {
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    display: inline-block;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    box-sizing: border-box;
    margin-right: 20px;
    cursor: pointer;
  }

  .containtitle .textType span.active {
    border: 2px solid rgba(32, 38, 204, 1);
    font-weight: 500;
    color: rgba(32, 38, 204, 1);
  }

  .containtitle .zhText, .enText {
    font-size: 14px;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    margin-bottom: 12px;
  }

  .containtitle .zhText img {
    width: 10px;
    height: 8px;
    margin-right: 5px;
  }

  .containtitle .enText img {
    width: 10px;
    height: 8px;
    margin-right: 5px;
  }

  .containtitle .imageText .activeImageText {
    margin: 17px 0;
  }

  .containtitle .imageText span {
    font-size: 14px;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    margin-right: 46px;
    cursor: pointer;
  }

  .containtitle .imageText span img {
    width: 10px;
    height: 8px;
    margin-right: 5px;
  }

  .containtitle .imageText span.imageTextActive {
    color: rgba(51, 51, 51, 1);
  }

  .photoAlbum {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
  }

  .photoAlbum span {
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-left: 12px;
  }

  .uploadImage {
    width: 105px;
    height: 105px;
  }

  .uploadImage img.add {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  .typeLeft {
    float: left;
    width: 270px;
  }

  .timeRight {
    float: left;
  }

  .real-name {
    position: relative;
  }

  .real-name span {
    position: absolute;
    top: 50%;
    right: 5px;
    color: #999;
    font-size: 12px;
    transform: translate(0, -50%);
  }

  em {
    font-style: normal;
  }

  #peopleDT {
    width: 100%;
    height: 200px;
    outline: none;
    border: 1px solid rgba(224, 224, 224, 1);
    box-sizing: border-box;
    margin-bottom: 25px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .textareaname span {
    bottom: 20px;
    top: auto;
    right: 5px;
    transform: none;
  }

  .textareaname textarea {
    padding: 21px 15px;
  }

  input[type='radio'] + label::before {
    content: '\a0';
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    width: 17px;
    height: 17px;
    margin-right: 0.4em;
    border-radius: 50%;
    border: 1px solid rgba(151, 151, 151, 1);
    text-indent: 0.15em;
    line-height: 1;
    cursor: pointer;
    box-sizing: border-box;
  }

  input[type='radio']:checked + label::before {
    background-color: #027aff;
    background-clip: content-box;
    padding: 2px;
  }

  input[type='radio'] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
  }

  .female {
    position: relative;
    float: left;
    // width: 100px;
    line-height: 25px;

    label {
      margin-right: 10px;
    }
  }

  input::-webkit-input-placeholder {
    color: #999;
    text-align: right;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #999;
    text-align: right;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #999;
    text-align: right;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #999;
    text-align: right;
  }

  .userinfortit1 input::-webkit-input-placeholder {
    text-align: left;
  }

  .userinfortit1 input::-moz-placeholder { /* Mozilla Firefox 19+ */
    text-align: left;
  }

  .userinfortit1 input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    text-align: left;
  }

  .userinfortit1 input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    text-align: left;
  }

  .phonenum input::-webkit-input-placeholder {
    text-align: left;
    font-size: 16px;
  }

  .phonenum input::-moz-placeholder { /* Mozilla Firefox 19+ */
    text-align: left;
    font-size: 16px;
  }

  .phonenum input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    text-align: left;
    font-size: 16px;
  }

  .phonenum input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    text-align: left;
    font-size: 16px;
  }

  .phonenum .el-input__inner::-webkit-input-placeholder {
    font-size: 12px;
  }

  .phonenum .el-input__inner::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 12px;
  }

  .phonenum .el-input__inner:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 12px;
  }

  .phonenum .el-input__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
    font-size: 12px;
  }

  .el-select-dropdown .el-select-dropdown__item {
    width: 250px;
  }

  .el-select-dropdown .el-select-dropdown__item .areacode {
    float: right;
  }

  .otherCreaterStyle {
    margin-top: 10px;
    position: relative;

    .drap {
      position: absolute;
      width: 150px;
      z-index: 1;
      background: rgba(0, 0, 0, 0);
    }

    span.roleLen {
      margin-left: -75px;
      z-index: 10;
      position: relative;
      padding-right: 30px;
      display: inline-block;
    }

    .otherCitem {
      // margin-top: 0.06rem;
      margin-bottom: 20px;
      cursor: pointer;

      .fanHead {
        width: 30px;
        height: 30px;
        border-radius: 15px;
      }

      .nickname {
        font-size: 14px;
        display: inline-block;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
    }

    .role {
      display: inline-block;
      width: 250px;
      margin: 0 20px;
    }

    span.deleteOC {
      border-radius: 0.06rem;
      cursor: pointer;
      color: #0A0A0A;
      font-size: 14px;
      display: inline-block;
    }
  }

  .otherCreaterStyle::-webkit-scrollbar {
    width: 6px;
    height: 16px;
  }

  .otherCreaterStyle::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .otherCreaterStyle::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(210, 210, 210, 0.5);
  }

  .fanHead {
    width: 0.32rem;
    height: 0.32rem;
    margin: -0.02rem 0.1rem 0 0;
  }

  .upInput, .upInputIMG, .upInputIMG1 {
    display: none;
  }

  .containerSwcond {
    padding: 0 165px;

    .stepStatus {
      height: 124px;
      width: 100%;
      line-height: 124px;
      border-bottom: 1px solid #E0E0E0;
      text-align: center;

      .step {
        display: inline-block;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;

        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 1px solid rgba(153, 153, 153, 1);
          box-sizing: border-box;
          vertical-align: middle;
          line-height: 24px;
          color: rgba(153, 153, 153, 1);
          margin-right: 10px;
          margin-bottom: 3px;
        }
      }

      .completed {
        color: #1FCD72;

        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          vertical-align: text-top;
        }
      }

      .active {
        color: rgba(10, 10, 10, 1);

        span {
          border: 1px solid rgba(10, 10, 10, 1);
          color: rgba(10, 10, 10, 1);
        }
      }

      .img-right {
        display: inline-block;
        width: 10px;
        height: 14px;
        margin: 0 40px;
      }
    }

    .step1Box {
      width: 730px;
      position: relative;
      padding-top: 66px;
    }

    .operate-btn {
      width: 100%;
      justify-content: space-between;
      line-height: 40px;
      height: 40px;
      text-align: right;
      font-size: 16px;
      color: #fff;
      background-color: #fff;
      font-weight: 500;
      padding: 60px 0 120px;

      .publish {
        display: inline-block;
        cursor: pointer;
        width: 144px;
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(153, 153, 153, 1);
        color: #333;
        margin-right: 30px;
        text-align: center;
        background: none;
        border-radius: 0;
      }

      .review {
        text-align: center;
        display: inline-block;
        cursor: pointer;
        width: 144px;
        height: 40px;
        color: #fff;
        line-height: 40px;
        // border-radius: 3px;
        background: rgba(32, 38, 204, 1);
      }
    }

    .radio-wrap {
      display: flex;
      margin-top: 0.36rem;

      .radio-head {
        color: #000000;
        font-size: 0.18rem;
      }

      .radio-cho {
        margin-top: 0.01rem;
      }
    }

    .moreMessage {
      /* height 5.64rem */
      padding: 0 3rem 0.8rem;
      margin-top: 0.2rem;
      /* overflow hidden */
      background-color: #ffffff;
    }

    .industry {
      margin-top: 0.3rem;
    }

    .choose-subject {
      // height 5.22rem
      padding: 0 3rem 0.6rem;
      margin-top: 0.2rem;
      overflow: hidden;
      background-color: #ffffff;

      .sub-head {
        color: #000000;
        font-size: 16px;
        padding-top: 0.3rem;
      }

      .tolabout {
        display: inline-block;
        float: left;
      }

      .sub-content {
        display: flex;
        flex-wrap: wrap;

        .sub-item {
          margin: 0.39rem 0.34rem 0 0;
          display: flex;

          .choose-item {
            width: 0.18rem;
            height: 0.18rem;
            background: url('/static/uploadvideo/chooseItem.png') no-repeat;
            background-size: 0.18rem 0.18rem;
          }

          .choose-con {
            font-size: 0.2rem;
            color: #000000;
            margin: -0.06rem 0 0 0.1rem;
          }
        }
      }
    }

    .hot-label {
      display: flex;
      color: #333333;
      font-size: 12px;

      .title {
        padding-top: 0.3rem;
      }
    }

    .choose-label {
      display: flex;
      flex-wrap: wrap;

      .label {
        margin: 0.2rem 0.2rem 0 0;
        display: flex;
        /* width 1.4rem */
        height: 0.4rem;
        line-height: 0.4rem;
        background-color: #f9f9f9;
        border-radius: 0.2rem;
        border: solid 1px #dddddd;
        color: #999999;
        font-size: 0.18rem;
        position: relative;
        justify-content: space-between;

        .font {
          /* width 1.05rem */
          padding: 0 0.18rem;
          text-align: center;
        }

        span {
          position: absolute;
          right: 0.35rem;
        }

        .close {
          width: 0.35rem;
        }

        img {
          display: block;
          width: 0.1rem;
          height: 0.1rem;
          margin: 0.15rem auto;
        }
      }
    }

    .fixcation {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.3;
      z-index: 999;
      background-color: #000;
    }

    .phoneCertification {
      position: fixed;
      z-index: 1000;
      top: 50%;
      left: 50%;
      width: 390px;
      height: 393px;
      border-radius: 5px;
      margin: -196.5px 0 0 -195px;
      background-color: #fff;
    }

    .phoneCertification .userphone {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #E9EAED;
      box-sizing: border-box;
    }

    .phoneCertification .areainfor {
      padding: 40px 48px 0;
    }

    .phoneCertification .areainfor p {
      color: #999;
      font-size: 14px;
      margin-bottom: 44px;
    }

    .phoneCertification .phonenum {
      overflow: hidden;
      border-bottom: 1px solid #E9EAED;
    }

    .tps29 {
      margin-top: 29px;
    }

    .onloadings .right span {
      float: right;
    }

    .phoneCertification .phonenum .leftside {
      position: relative;
      float: left;
      width: 76px;
      height: 50px;
      border: none;
      outline: none;
      font-size: 16px;
      appearance: none;
      -o-appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      background-color: #fff;
    }

    select::-ms-expand {
      display: none;
    }

    .phoneCertification .phonenum .usercode {
      line-height: 50px;
    }

    .phoneCertification .phonenum input {
      float: left;
      width: calc(100% - 76px);
      height: 50px;
      font-size: 16px;
      padding-left: 10px;
      box-sizing: border-box;
    }

    .phoneCertification .tps29 input {
      width: 150px;
    }

    .phoneCertification .tps29 .havecode {
      display: inline-block;
      float: left;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      color: #333;
      cursor: pointer;
    }

    .phoneCertification .tps29 .havecodehase {
      display: inline-block;
      float: left;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      color: #999;
      cursor: pointer;
    }

    .phoneCertification .submitbtns {
      display: block;
      width: 184px;
      height: 40px;
      margin: 44px auto 0;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 40px;
      border-radius: 3px;
      cursor: pointer;
      background: rgba(3, 161, 214, 1);
    }

    .closepopus {
      position: absolute;
      width: 17px;
      height: 17px;
      top: 16px;
      right: 13px;
      cursor: pointer;
    }

    .addLabel {
      // padding: 0 80px 20px;c
      margin-top: 0.2rem;
      overflow: hidden;
      background-color: #ffffff;
      // padding-bottom: 0.3rem;
    }

    .editTitles {
      width: 100%;
    }

    .stick {
      display: inline-block;
      margin-left: 0.3rem;
      width: 0.9rem;
      height: 0.3rem;
      background: #0060ff;
      color: #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 0.3rem;
      cursor: pointer;
    }

    .alHead {
      padding-top: 36px;
      font-size: 20px;
      color: #000;
      font-weight: bold;

      span {
        color: #999999;
        font-size: 12px;
      }
    }

    .upload {
      float: left;
      width: 105px;
      height: 105px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // border-radius: 5px;
      margin: 0 20px 20px 0;
      position: relative;

      &:nth-child(6n) {
        margin-right: 0;
      }
    }

    .upload .deteleImg {
      position: absolute;
      width: 25px;
      height: 25px;
      right: -8px;
      top: -8px;
      cursor: pointer;
      display: none;
    }

    .upload:hover .deteleImg {
      display: block;
    }

    .clickloads {
      position: relative;
      float: left;
      margin-right: 0;
      background-color: #f3f3f3;
    }

    // .clickloads img {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // width: 31px;
    // height: 29px;
    // margin: -14.5px 0 0 -15.5px;
    // }
    .clickloads .font {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 55px;
      height: 22px;
      line-height: 22px;
      color: #fff !important;
      font-size: 12px !important;
      border-radius: 3px;
    }

    .clickloads .add-wrap {
      border-radius: 5px;
      cursor: pointer;

      /* .add {
        display: block;
        width: 0.8rem;
        height: 0.8rem;
        margin: 0.55rem auto 0.1rem;
      } */
      .font {
        color: #333333;
        text-align: center;
        font-size: 0.22rem;
      }
    }

    .add-wrap-active {
      border: none;
    }

    .editTitles p {
      // margin-top: 30px;
    }

    .editTitles .font span {
      font-size: 12px;
      color: #999;
      margin-left: 8px;
    }

    .moretitle {
      overflow: hidden;
    }

    .moretitle span {
      display: inline-block;
      float: left;
      height: 30px;
      cursor: pointer;
      line-height: 30px;
      padding: 0 12px;
      margin: 0 10px 10px 0;
      background: rgba(245, 245, 245, 1);
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }

    .moretitle .active {
      color: #fff;
      background: rgba(32, 38, 204, 1);
    }

    .clickaddtitle1 {
      display: inline-block;
      // position: relative;
      float: left;
      padding: 0 14px;
      height: 30px;
      cursor: pointer;
      text-align: center;
      color: #999;
      margin: 0 10px 10px 0;
      line-height: 30px;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid rgba(224, 224, 224, 1);

      i {
        // position: absolute;
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
        background: url('/static/uploadvideo/edit_icon@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .userinfortit1 {
      position: relative;
      float: left;
      // width: 150px;
      height: 30px;
      border: 1px solid rgba(32, 38, 204, 0.85);
      box-sizing: border-box;
      font-size: 0;

      input[type='text'] {
        font-size: 14px;
        padding-left: 10px;
        width: 150px;
        height: 100%;
        padding-left: 10px;
        padding-right: 38px;
        box-sizing: border-box;
        float: left;
      }

      a {
        position: absolute;
        right: 0;
        top: 0;
        padding: 0 5px;
        height: 30px;
        cursor: pointer;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        background: rgba(32, 38, 204, 0.08);
        font-weight: 500;
        color: rgba(32, 38, 204, 1);
      }
    }

    .upload-wrap {
      /* height 6.32rem */
      /* overflow hidden */
      padding-top: 106px;
      background-color: #ffffff;

      .up-head {
        color: #000000;
        font-size: 16px;

        span {
          color: #999999;
          font-size: 12px;
        }
      }

      .bline {
        width: 100%;
        height: 0.02rem;
        background: #dcdfe6;
        margin-top: 0.3rem;
      }

      // .upcontent {
      // overflow: hidden;
      // }
      .modify-btn {
        width: 1.55rem;
        height: 0.46rem;
        margin: 0.3rem 0.86rem 0;
        line-height: 0.46rem;
        font-size: 0.18rem;
        text-align: center;
        color: #0161ff;
        cursor: pointer;
        border-radius: 0.23rem;
        border: solid 1px #0161ff;
      }
    }

    .basic-wrap {
      margin-top: 0.2rem;
      background-color: #ffffff;
    }

    .contain {
      select {
        width: 4.5rem;
        height: 0.5rem;
        margin-top: 0.1rem;
        background-color: #F9F9F9;
        border-radius: 0.08rem;
        text-indent: 0.1rem;
        outline: none;
        border: none;
        font-size: 0.18rem;
      }

      .special {
        display: flex;
        justify-content: space-between;
      }

      #area {
        display: block;
        width: 1.22rem;
      }

      .city {
        display: block;
        width: 3.08rem;
        margin-left: 0.2rem;
      }

      .resetW {
        width: 14.79rem;
      }
    }

    .progress-wrap {
      background-color: #ffffff;
      position: absolute;
      right: -379px;
      top: 66px;
      width: 349px;

      .progress-head {
        justify-content: space-between;

        .uploadVideo {
          padding: 8px 25px;
          background: #3664ed;
          font-size: 16px;
          color: #fff;
          border-radius: 4px;
          line-height: 24px;
          cursor: pointer;

          &.has {
            float: right;
          }
        }

        .left {
          font-size: 14px;
          color: rgba(0, 0, 0, 1);
          font-weight: bold;
        }

        .right {
          font-size: 14px;
          margin-top: 8px;
          color: rgba(153, 153, 153, 1);

          span {
            display: inline-block;
            margin-left: 0.3rem;
          }
        }
      }

      .progress {
        position: relative;
        height: 8px;
        background: rgba(184, 184, 184, 1);
      }

      .p-top {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 8px;
        background: rgba(32, 38, 204, 1);
      }
    }
  }

  .no-identificaton {
    padding: 80px 0 120px;

    .up-video {
      width: 730px;
      height: 440px;
      border-radius: 4px;
      border: 2px dashed rgba(224, 224, 224, 1);
      box-sizing: border-box;
      margin: 0 auto;

      .upBox {
        width: 100px;
        height: 100px;
        margin: 35px auto 14px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .upTitle1 {
        font-size: 16px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: center;
      }

      .upTitle2 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        margin: 14px 0;
      }

      .upload-button {
        width: 140px;
        height: 44px;
        background: rgba(32, 38, 204, 1);
        margin-left: 50%;
        transform: translateX(-50%);
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }

      .disable-button {
        background: rgba(224, 224, 224, 1);
        color: rgba(255, 255, 255, 1);
      }

      .upTitle3 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-align: center;
        margin: 50px 0 8px;
      }

      .upTitle4 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-align: center;
      }

      .upTitle5 {
        font-size: 14px;
        font-weight: 600;
        color: #666;
        text-align: center;
        margin-top: 9px;

        span {
          color: #FE5630;
        }
      }
    }

    .Protocol {
      text-align: center;
      margin: 40px 0 14px;
      color: #666;
      font-weight: 400;
      font-size: 14px;
    }

    .upTitle6 {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }

    .top-choose {
      text-align: center;
      margin-top: 24px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);

      .hmessage {
        display: inline-block;
        cursor: pointer;
      }

      span {
        margin: 0 14px;
      }
    }
  }

  .havecidehase {
    display: inline-block;
    width: 68px;
    height: 50px;
    color: #999;
    line-height: 50px;
    white-space: nowrap;
  }

  .reUpload {
    position: absolute;
    top: 22px;
    right: 0;
    color: #fff;
    font-size: 13px;
    padding: 3px 7px;
    border-radius: 3px;
    cursor: pointer;
    background-color: #027aff;
  }

  .explain {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 22px;
  }
}

.step2Box {
  padding: 50px 95px 120px;

  .step2_title1 {
    font-size: 24px;
    font-weight: 500;
    color: rgba(10, 10, 10, 1);
  }

  .step2_title2 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 196, 0, 1);
    margin: 8px 0 42px 0;
  }

  .title_text {
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-bottom: 22px;

    i {
      color: #FE5630;
      font-size: 16px;
    }

    span {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-right: 12px;
    }
  }

  .step2_type, .step2_industry, .step2_scene, .step2_hot {
    margin-bottom: 50px;
  }

  .step2_tool {
    margin-bottom: 70px;
  }

  .step2_buttom {
    text-align: center;

    .back {
      display: inline-block;
      padding: 0 48px;
      height: 40px;
      line-height: 40px;
      border: 1px solid rgba(153, 153, 153, 1);
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-right: 30px;
      cursor: pointer;
    }

    .next {
      display: inline-block;
      padding: 0 48px;
      height: 40px;
      line-height: 40px;
      background: rgba(32, 38, 204, 1);
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      cursor: pointer;
    }
  }

  .step2_type {
    .selelTitle {
      display: inline-block;
      padding: 0 13px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: rgba(32, 38, 204, 1);
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
  }
}

.step3Box {
  padding: 50px 95px 120px;

  .condition {
    .condition_title {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 22px;

      i {
        color: #FE5630;
        font-size: 16px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-right: 12px;
      }
    }

    .condition_ter {
      .left_ter {
        float: left;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-right: 40px;

        span {
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 2px solid rgba(184, 184, 184, 1);
          vertical-align: middle;
          box-sizing: border-box;
          margin-right: 10px;
          cursor: pointer;
        }

        span.active {
          border: 0;
          background: url('/static/uploadvideo/icon_upload_multi_selected@2x.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .right_ter {
        float: left;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);

        span {
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 2px solid rgba(184, 184, 184, 1);
          vertical-align: middle;
          box-sizing: border-box;
          margin-right: 10px;
          cursor: pointer;
        }

        span.active {
          border: 0;
          background: url('/static/uploadvideo/icon_upload_multi_selected@2x.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
  }

  .mode {
    margin: 50px 0 70px 0;

    .mode_title {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 22px;

      i {
        color: #FE5630;
        font-size: 16px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-right: 12px;
      }
    }

    .mode_ter {
      .left_ter {
        height: 40px;
        line-height: 40px;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-right: 40px;

        span {
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 2px solid rgba(184, 184, 184, 1);
          vertical-align: middle;
          box-sizing: border-box;
          margin-right: 10px;
          cursor: pointer;
        }

        span.active {
          border: 0;
          background: url('/static/uploadvideo/icon_upload_multi_selected@2x.png') no-repeat center center;
          background-size: 100% 100%;
        }

        .el-select {
          margin-left: 10px;
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }

  .step3_bottom {
    text-align: center;

    .step3_back {
      display: inline-block;
      padding: 0 48px;
      height: 40px;
      line-height: 40px;
      border: 1px solid rgba(153, 153, 153, 1);
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-right: 30px;
      cursor: pointer;
    }

    .step3_dri {
      display: inline-block;
      padding: 0 48px;
      height: 40px;
      line-height: 40px;
      background: rgba(32, 38, 204, 1);
      // background:rgba(224,224,224,1);
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      cursor: pointer;
    }
  }
}

.typePop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 111;

  .typePopBox {
    width: 730px;
    min-height: 270px;
    padding-bottom: 30px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .type_title {
      padding-left: 30px;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E0E0E0;
      font-size: 18px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      position: relative;

      .most {
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        magrin-left: 12px;
      }

      .close {
        position: absolute;
        color: #999999;
        right: 24px;
        top: 25px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .categoryLabel {
      margin-top: 30px;
      padding: 0 30px;
    }

    .subdivide {
      margin: 30px 0 88px 0;
      padding: 0 30px;

      .subdivide_title {
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 12px;
      }
    }

    .selected {
      margin-bottom: 40px;
      padding: 0 30px;

      .selected_title {
        font-size: 13px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 12px;

        .uplimit {
          font-size: 13px;
          font-weight: 400;
          color: rgba(254, 86, 48, 1);
          margin-left: 20px;
        }
      }

      .selected_label_title {
        span {
          position: relative;
          float: left;
          padding: 0 24px 0 14px;
          height: 30px;
          line-height: 30px;
          background: rgba(32, 38, 204, 0.1);
          font-size: 14px;
          font-weight: 500;
          color: rgba(32, 38, 204, 1);
          margin: 0 10px 10px 0;

          i {
            color: #B8B8B8;
            cursor: pointer;
            position: absolute;
            width: 14px;
            height: 14px;
            right: 5px;
            top: 8px;
            background: url('/static/uploadvideo/tag_del_btn@2x.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }

    .determine {
      margin: 0 auto;
      width: 78px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      background: rgba(32, 38, 204, 1);
      cursor: pointer;
    }

    .label_title {
      span {
        display: inline-block;
        float: left;
        height: 30px;
        font-size: 14px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
        padding: 0 12px;
        cursor: pointer;
        margin: 0 10px 10px 0;
        background: rgba(245, 245, 245, 1);
        box-sizing: border-box;

        &.active {
          color: #fff;
          background: rgba(32, 38, 204, 1);
        }
      }

      .clickaddtitle1 {
        display: inline-block;
        float: left;
        height: 30px;
        cursor: pointer;
        text-align: center;
        color: #666;
        font-weight: 400;
        margin: 0 10px 10px 0;
        line-height: 30px;
        font-size: 14px;
        border: 1px solid rgba(224, 224, 224, 1);
        box-sizing: border-box;
        padding: 0 13px;
      }

      .userinfortit1 {
        position: relative;
        float: left;
        // width: 150px;
        height: 30px;
        border: 1px solid rgba(32, 38, 204, 0.85);
        box-sizing: border-box;
        font-size: 0;

        input[type='text'] {
          font-size: 14px;
          padding-left: 10px;
          width: 150px;
          height: 100%;
          padding-left: 10px;
          padding-right: 38px;
          box-sizing: border-box;
          float: left;
        }

        a {
          position: absolute;
          right: 0;
          top: 0;
          padding: 0 5px;
          height: 30px;
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          background: rgba(32, 38, 204, 0.08);
          font-weight: 500;
          color: rgba(32, 38, 204, 1);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/my/video/UpVideo.vue